var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroLostBgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 812,
    viewBox: "0 0 375 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6004_62530)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "url(#paint0_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "url(#paint1_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "url(#paint2_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-215.795 479.813H-215.817V479.84H-215.795V479.813Z",
    fill: "url(#paint3_linear_6004_62530)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.492 396.459L703.551 336.67L705.323 396.629C705.72 396.629 706.046 396.954 706.046 397.35V404.536H706.769C707.167 404.536 707.492 404.86 707.492 405.256V408.154C708.017 408.632 708.37 409.297 708.436 410.051L708.585 411.92C708.817 414.658 708.811 417.413 708.557 420.151L708.447 421.328C708.326 422.647 707.321 423.692 706.046 423.901V430.405H706.769C707.167 430.405 707.492 430.73 707.492 431.126V431.846C707.492 432.242 707.167 432.566 706.769 432.566H706.046V436.157H706.769C707.167 436.157 707.492 436.481 707.492 436.877V438.312C707.492 438.708 707.167 439.032 706.769 439.032H706.046V444.778H706.769C707.167 444.778 707.492 445.102 707.492 445.498V446.933C707.492 447.329 707.167 447.654 706.769 447.654H706.046V448.374H706.769C707.167 448.374 707.492 448.698 707.492 449.094V450.529C707.492 450.925 707.167 451.249 706.769 451.249H706.046V452.684H707.487C707.884 452.684 708.21 453.009 708.21 453.405V458.436C708.21 458.832 707.884 459.156 707.487 459.156H706.764V474.243C707.161 474.243 707.487 474.568 707.487 474.964V476.399C707.487 476.794 707.161 477.119 706.764 477.119V478.554C707.161 478.554 707.487 478.878 707.487 479.274V480.709C707.487 481.105 707.161 481.43 706.764 481.43V497.952H708.204C708.602 497.952 708.927 498.276 708.927 498.672V506.172H714.381C715.17 506.172 715.821 506.815 715.821 507.607V508.723H730.586V504.22C730.586 503.791 730.244 503.445 729.813 503.445C729.383 503.445 729.035 503.098 729.035 502.669V499.937C729.035 499.31 728.522 498.799 727.887 498.799C727.098 498.799 726.54 498.001 726.822 497.259L733.66 479.291C733.87 478.73 734.4 478.361 735.007 478.361H820.218C820.731 478.361 821.2 478.625 821.46 479.065L832.261 497.27C832.659 497.946 832.179 498.799 831.384 498.799C830.832 498.799 830.368 499.249 830.368 499.81V502.004C830.368 502.796 829.728 503.439 828.928 503.439H828.707C827.918 503.439 827.266 504.082 827.266 504.874V508.712H836.744V474.045C836.744 473.688 837.036 473.397 837.395 473.397C837.753 473.397 838.052 473.105 838.052 472.748V459.865C838.052 459.073 838.692 458.43 839.492 458.43H863.271V456.995C863.271 456.203 863.916 455.56 864.711 455.56H871.219C871.853 455.56 872.416 455.148 872.598 454.543L875.943 443.645C876.126 443.04 876.688 442.628 877.323 442.628H958.83C959.619 442.628 960.271 443.271 960.271 444.063V508.718V584.628H601.103H34.9855H-315.804V494.977V491.15C-315.804 490.359 -315.158 489.715 -314.363 489.715H-313.585C-312.79 489.715 -312.144 489.072 -312.144 488.28V481.331C-312.144 480.539 -311.498 479.895 -310.704 479.895H-284.569C-283.774 479.895 -283.128 480.539 -283.128 481.331V488.28C-283.128 489.072 -282.482 489.715 -281.687 489.715H-278.906C-278.127 489.715 -277.498 490.342 -277.498 491.117C-277.498 491.893 -276.869 492.52 -276.091 492.52H-268.225C-267.69 492.52 -267.193 492.816 -266.95 493.289L-261.602 503.434C-261.491 503.637 -261.436 503.868 -261.436 504.099V509.339H-255.243V499.238C-255.243 498.381 -253.996 498.249 -253.814 499.09L-253.483 500.63L-251.523 500.624L-251.319 499.249C-251.203 498.447 -250.049 498.419 -249.9 499.216L-249.635 500.591V500.63L-245.755 500.624L-245.551 499.249C-245.435 498.447 -244.281 498.419 -244.132 499.216L-243.867 500.591V500.63L-242.874 500.624L-242.67 499.249C-242.554 498.447 -241.4 498.419 -241.251 499.216L-240.992 500.591C-240.986 500.597 -240.986 500.613 -240.986 500.613V500.63L-240.71 500.624L-240.506 499.249C-240.39 498.447 -239.237 498.419 -239.088 499.216L-238.823 500.591V500.613V500.63H-238.414L-238.083 499.09C-237.901 498.243 -236.653 498.375 -236.653 499.238V509.339H-221.132V469.845H-221.017L-220.873 468.575C-220.774 467.744 -219.57 467.717 -219.438 468.547L-219.245 469.845H-218.676L-218.533 468.575C-218.428 467.744 -217.225 467.717 -217.103 468.547L-216.882 469.993H-211.374L-211.214 468.575C-211.114 467.744 -209.911 467.717 -209.779 468.547L-209.564 469.993H-209.028L-208.868 468.575C-208.763 467.744 -207.56 467.717 -207.438 468.547L-207.218 469.993H-206.936V479.753H-203.271V458.177H-203.045V458.15V458.106L-202.769 455.483C-202.681 454.609 -201.4 454.625 -201.334 455.5L-201.13 458.122V458.177H-197.768V458.106L-197.492 455.483C-197.404 454.609 -196.123 454.625 -196.057 455.5L-195.853 458.122V458.177H-195.058V438.631H-194.407L-194.225 437.883C-194.037 437.13 -192.955 437.163 -192.812 437.922L-192.679 438.625H-192.216L-189.489 430.746L-188.429 415.285H-188.468C-189.677 415.285 -190.659 414.306 -190.659 413.097C-190.659 411.887 -189.688 410.908 -188.468 410.908C-187.248 410.908 -186.266 411.887 -186.266 413.097C-186.266 414.213 -187.11 415.137 -188.192 415.269L-187 430.746L-184.554 438.625H-184.223L-183.688 437.014C-183.462 436.333 -182.474 436.366 -182.302 437.069L-181.922 438.631H-181.872V438.867C-181.866 438.917 -181.866 438.966 -181.872 439.01V458.177H-179.89V458.15V458.106L-179.614 455.483C-179.526 454.609 -178.246 454.625 -178.179 455.5L-177.975 458.122V458.177L-177.837 458.172V458.139C-177.837 458.128 -177.832 458.106 -177.832 458.106L-177.567 455.483C-177.478 454.609 -176.198 454.625 -176.132 455.5L-175.927 458.122C-175.927 458.139 -175.922 458.177 -175.922 458.177H-175.718V479.753H-174.547V469.993H-174.266L-174.045 468.547C-173.913 467.722 -172.709 467.744 -172.616 468.575L-172.45 469.993H-171.926L-171.705 468.547C-171.572 467.722 -170.369 467.744 -170.275 468.575L-170.11 469.993H-164.607L-164.386 468.547C-164.254 467.722 -163.05 467.744 -162.956 468.575L-162.807 469.845H-162.244L-162.04 468.547C-161.908 467.722 -160.704 467.744 -160.611 468.575L-160.462 469.845H-160.202V509.339H-150.885L-150.974 498.26C-150.985 497.408 -149.759 497.254 -149.555 498.084L-148.97 500.476H-148.401L-148.192 498.529C-148.098 497.688 -146.878 497.666 -146.757 498.502L-146.475 500.47H-146.238L-146.028 498.524C-145.934 497.682 -144.714 497.66 -144.593 498.496L-144.311 500.465H-144.074L-143.864 498.518C-143.771 497.677 -142.551 497.655 -142.429 498.491L-142.148 500.459H-141.187L-140.978 498.513C-140.884 497.671 -139.664 497.649 -139.543 498.485L-139.261 500.454H-139.024L-138.814 498.507C-138.72 497.666 -137.5 497.644 -137.379 498.48L-137.075 500.597H-136.154L-135.927 498.507C-135.833 497.666 -134.614 497.644 -134.492 498.48L-134.189 500.597H-133.841L-133.355 498.628C-133.145 497.803 -131.931 497.952 -131.937 498.804L-131.981 509.311H-123.944V485.553C-123.944 485.075 -124.187 484.624 -124.585 484.36L-124.772 484.239C-125.175 483.97 -125.413 483.519 -125.413 483.041V482.155C-125.413 481.364 -124.767 480.72 -123.972 480.72H-123.85C-123.31 480.72 -122.807 480.418 -122.564 479.939L-116.504 468.162C-116.256 467.684 -115.759 467.381 -115.218 467.381H-73.5785C-73.0155 467.381 -72.5021 467.706 -72.2648 468.212L-66.5796 480.434C-66.4913 480.621 -66.4417 480.83 -66.4417 481.039V485.603C-66.4417 485.96 -66.1492 486.252 -65.7904 486.252C-65.4316 486.252 -65.1335 486.543 -65.1335 486.9V509.311H-23.1187L-2.48666 491.695C-2.22173 491.475 -1.89613 491.354 -1.5484 491.354H6.02994C6.37767 491.354 6.71443 491.48 6.97385 491.706L10.131 494.444L15.5843 432.445H18.1067L28.4172 509.311H34.9855V482.826C34.9855 482.529 35.0794 482.238 35.2505 481.996L49.2977 462.142C49.4412 461.938 49.6289 461.784 49.8331 461.685V461.174H92.3943C93.0291 461.174 93.5921 461.586 93.7742 462.191L97.119 473.089C97.3012 473.693 97.8642 474.106 98.4989 474.106H105.006C105.796 474.106 106.447 474.749 106.447 475.541V513.616H119.429V482.788C119.429 482.513 119.512 482.243 119.661 482.012L131.831 463.142C132.499 462.098 134.089 462.334 134.425 463.527L148.633 513.616H164.518V504.088C164.518 503.659 164.176 503.313 163.745 503.313C163.315 503.313 162.967 502.966 162.967 502.537V499.805C162.967 499.178 162.454 498.667 161.819 498.667C161.03 498.667 160.472 497.869 160.754 497.127L167.592 479.159C167.802 478.598 168.332 478.23 168.939 478.23H206.792C207.14 478.23 207.421 477.955 207.421 477.608C207.421 477.262 207.14 476.987 206.792 476.987H206.483C205.97 476.987 205.55 476.569 205.55 476.058V475.904C205.55 475.304 206.041 474.821 206.638 474.821H224.355C225.123 474.821 225.752 475.442 225.752 476.212V476.674C225.752 477.185 225.332 477.603 224.813 477.603H224.195C224.024 477.603 223.886 477.74 223.886 477.911C223.886 478.081 224.024 478.219 224.195 478.219H254.144C254.658 478.219 255.127 478.482 255.386 478.922L266.188 497.127C266.585 497.803 266.105 498.656 265.31 498.656C264.758 498.656 264.295 499.107 264.295 499.667V501.861C264.295 502.653 263.655 503.296 262.854 503.296H262.628C261.839 503.296 261.187 503.94 261.187 504.731V508.569H270.664V473.182C270.664 472.825 270.957 472.533 271.316 472.533C271.674 472.533 271.972 472.242 271.972 471.884V459.002C271.972 458.21 272.613 457.567 273.413 457.567H330.137C330.927 457.567 331.578 458.21 331.578 459.002V471.884C331.578 472.242 331.871 472.533 332.229 472.533C332.588 472.533 332.886 472.825 332.886 473.182V477.652H347.033L350.24 467.2C350.422 466.595 350.985 466.183 351.62 466.183H392.74C393.529 466.183 394.181 466.826 394.181 467.618V477.652H443.603L449.603 465.974C449.851 465.495 450.348 465.193 450.889 465.193H492.528C493.091 465.193 493.604 465.517 493.842 466.023L499.527 478.246C499.615 478.433 499.665 478.642 499.665 478.851V483.414C499.665 483.772 499.957 484.063 500.316 484.063C500.675 484.063 500.973 484.355 500.973 484.712V508.564H541.31L564.028 489.166H572.683L595.037 508.564H601.103V480.643C601.103 480.346 601.197 480.055 601.368 479.813L615.415 459.959C615.559 459.755 615.746 459.601 615.951 459.502V458.991H658.512C659.147 458.991 659.71 459.403 659.892 460.008L663.236 470.906C663.419 471.511 663.982 471.923 664.616 471.923H671.124C671.913 471.923 672.565 472.566 672.565 473.358V508.558H685.547V507.442C685.547 506.65 686.192 506.007 686.987 506.007H698.887V498.507C698.887 498.111 699.213 497.787 699.61 497.787H701.051V481.265C700.653 481.265 700.328 480.94 700.328 480.544V479.109C700.328 478.713 700.653 478.389 701.051 478.389V476.954C700.653 476.954 700.328 476.63 700.328 476.234V474.799C700.328 474.403 700.653 474.078 701.051 474.078V458.991H700.328C699.931 458.991 699.605 458.667 699.605 458.271V453.24C699.605 452.844 699.931 452.52 700.328 452.52H701.768V451.084H701.045C700.648 451.084 700.322 450.76 700.322 450.364V448.929C700.322 448.533 700.648 448.209 701.045 448.209H701.768V447.489H701.045C700.648 447.489 700.322 447.164 700.322 446.768V445.333C700.322 444.937 700.648 444.613 701.045 444.613H701.768V438.867H701.045C700.648 438.867 700.322 438.543 700.322 438.147V436.712C700.322 436.316 700.648 435.992 701.045 435.992H701.768V432.401H701.045C700.648 432.401 700.322 432.077 700.322 431.681V430.961C700.322 430.565 700.648 430.24 701.045 430.24H701.768V423.769C700.515 423.698 699.467 422.752 699.296 421.493C698.782 417.754 698.76 413.971 699.229 410.232L699.285 409.748C699.384 408.99 699.765 408.335 700.322 407.884V405.086C700.322 404.69 700.648 404.366 701.045 404.366H701.768V397.179C701.768 396.783 702.094 396.459 702.492 396.459ZM-215.795 479.813H-215.817V479.84H-215.795V479.813Z",
    fill: "url(#paint4_linear_6004_62530)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.803 551.375H-369.928V569.618H819.803V551.375Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.479 558.732L813.182 558.64",
    stroke: "white",
    strokeWidth: 0.514743,
    strokeDasharray: "2.57 2.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000699853 545.709L14.8927 544.759C17.8281 544.573 20.3163 542.545 21.1022 539.713L21.4494 538.449C21.6049 537.874 21.6188 537.272 21.4827 536.691L21.1633 535.317C20.408 532.087 15.848 531.993 14.9594 535.189L13.7986 532.959C12.1879 529.874 7.56404 530.685 7.09749 534.131C5.85892 529.61 -0.428349 529.279 -2.13347 533.648L-2.20289 533.823L-2.98326 532.992C-5.18825 530.637 -8.96228 530.746 -11.034 533.223C-12.8557 535.403 -12.6697 538.624 -10.6063 540.579L-8.70401 542.379C-10.7257 543.434 -9.83984 546.503 -7.56542 546.319L-0.000699853 545.706V545.709Z",
    fill: "#26C543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7822 539.789L58.5174 535.962C56.1597 534.721 54.7295 532.235 54.8378 529.575L54.9433 527.087C54.9683 526.442 55.1543 525.817 55.4848 525.262L56.3624 523.774C58.198 520.669 62.9635 522.074 62.8163 525.679L64.8519 523.621C67.5123 520.933 72.0472 523.279 71.3891 527.003C74.1745 522.66 80.8922 524.41 81.2088 529.561L82.3307 528.911C85.3994 527.134 89.3289 528.472 90.6758 531.752C91.8338 534.576 90.6202 537.817 87.8959 539.189L85.13 540.586H68.9952C67.8733 540.586 66.7708 540.314 65.7794 539.792L65.7822 539.789Z",
    fill: "#AACAC9",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7113 538.481L58.3646 536.593C56.6817 535.241 55.7292 533.177 55.7931 531.019L55.8764 528.226C55.8903 527.631 56.0569 527.051 56.3596 526.537L57.0705 525.318C58.7395 522.455 63.1273 523.705 63.0357 527.018L64.8019 525.229C67.2485 522.755 71.4279 524.885 70.8614 528.32C73.3747 524.363 79.4814 525.896 79.8286 530.572L79.8424 530.761L81.9947 529.32C84.0636 527.937 86.774 527.984 88.7902 529.439L89.5233 529.967C91.3701 531.3 92.0365 533.744 91.1229 535.832C90.6702 536.876 89.8565 537.723 88.8373 538.229L83.5387 540.853H70.8614L64.1159 539.948C62.8718 539.781 61.6916 539.276 60.7113 538.487V538.481Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.262 521.905H99.7236V536.057H135.262V521.905Z",
    fill: "#D8D0C3",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.262 531.834H99.7236V536.055H135.262V531.834Z",
    fill: "#D8D0C3",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.037 524.771H101.445V526.509H102.037V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.401 522.871H98.5889V523.443H136.401V522.871Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.037 528.781H101.445V530.519H102.037V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.23 532.79H100.491V536.055H102.23V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.814 532.79H104.12V536.055H106.814V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.016 532.79H108.322V536.055H111.016V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.216 532.79H112.522V536.055H115.216V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.34 533.374C116.34 532.735 116.859 532.219 117.498 532.219C118.137 532.219 118.65 532.735 118.65 533.374V536.057H116.34V533.374Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.474 532.79H119.78V536.055H122.474V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.676 532.79H123.982V536.055H126.676V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.066 532.79H128.372V536.055H131.066V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.311 532.79H132.765V536.055H134.311V532.79Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.284 524.771H104.692V526.509H105.284V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.284 528.781H104.692V530.519H105.284V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.385 524.771H106.794V526.509H107.385V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.385 528.781H106.794V530.519H107.385V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.485 524.771H108.894V526.509H109.485V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.485 528.781H108.894V530.519H109.485V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.392 524.771H110.801V526.509H111.392V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.392 528.781H110.801V530.519H111.392V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.687 524.771H113.096V526.509H113.687V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.687 528.781H113.096V530.519H113.687V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.594 524.771H115.003V526.509H115.594V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.594 528.781H115.003V530.519H115.594V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.888 524.771H117.297V526.509H117.888V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.888 528.781H117.297V530.519H117.888V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.18 524.771H119.589V526.509H120.18V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.18 528.781H119.589V530.519H120.18V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28 524.771H121.688V526.509H122.28V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28 528.781H121.688V530.519H122.28V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.188 524.771H123.597V526.509H124.188V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.188 528.781H123.597V530.519H124.188V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.481 524.771H125.89V526.509H126.481V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.481 528.781H125.89V530.519H126.481V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.585 524.771H127.993V526.509H128.585V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.585 528.781H127.993V530.519H128.585V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.491 524.771H129.899V526.509H130.491V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.491 528.781H129.899V530.519H130.491V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.546 524.771H132.954V526.509H133.546V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.546 528.781H132.954V530.519H133.546V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.839 521.905H99.1543V522.88H135.839V521.905Z",
    fill: "#095FE7",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2793 521.905H9.74121V536.057H45.2793V521.905Z",
    fill: "#97A8C3",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3388 532.79H9.78125V536.055H45.3388V532.79Z",
    fill: "#97A8C3",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0525 524.771H11.4609V526.509H12.0525V524.771Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.418 522.871H8.60547V523.443H46.418V522.871Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3388 528.799H9.78125V531.701H45.3388V528.799Z",
    fill: "#E6C784",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3223 532.79H9.78125V536.055H12.3223V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3388 532.79H9.78125V536.055H45.3388V532.79Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8285 532.79H14.1348V536.055H16.8285V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7546 532.79H18.8525V536.055H21.7546V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2319 532.79H22.5381V536.055H25.2319V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3564 533.374C26.3564 532.735 26.8758 532.219 27.5145 532.219C28.1532 532.219 28.667 532.735 28.667 533.374V536.057H26.3564V533.374Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4887 532.79H29.7949V536.055H32.4887V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6899 532.79H33.9961V536.055H36.6899V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0805 532.79H38.3867V536.055H41.0805V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3398 532.79H42.7988V536.055H45.3398V532.79Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0664 524.445H9.78125V527.711H46.0664V524.445Z",
    fill: "#E6C784",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0664 524.445H9.78125V524.809H46.0664V524.445Z",
    fill: "#FAEAC7",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0664 528.799H9.78125V529.163H46.0664V528.799Z",
    fill: "#FAEAC7",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0664 532.79H9.78125V533.153H46.0664V532.79Z",
    fill: "#FAEAC7",
    stroke: "#FAEAC7",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5603 528.781H42.9688V530.519H43.5603V528.781Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8559 521.905H9.1709V523.241H45.8559V521.905Z",
    fill: "#FFF9DE",
    stroke: "#5B5563",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0664 521.905H9.78125V522.269H46.0664V521.905Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.426 521.905H355.888V536.057H391.426V521.905Z",
    fill: "#F4EEE0",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.426 531.834H355.888V536.056H391.426V531.834Z",
    fill: "#979A9F",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.199 524.771H357.607V526.509H358.199V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.565 522.872H354.752V523.444H392.565V522.872Z",
    fill: "#C9BC8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.199 528.781H357.607V530.52H358.199V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.394 532.79H356.655V536.056H358.394V532.79Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.975 532.79H360.281V536.056H362.975V532.79Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.177 532.79H364.483V536.056H367.177V532.79Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.377 532.79H368.684V536.056H371.377V532.79Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.503 533.374C372.503 532.736 373.022 532.219 373.661 532.219C374.3 532.219 374.813 532.736 374.813 533.374V536.057H372.503V533.374Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.448 524.771H360.856V526.509H361.448V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.448 528.781H360.856V530.52H361.448V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.548 524.771H362.956V526.509H363.548V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.548 528.781H362.956V530.52H363.548V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.649 524.771H365.058V526.509H365.649V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.649 528.781H365.058V530.52H365.649V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.556 524.771H366.965V526.509H367.556V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.556 528.781H366.965V530.52H367.556V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.85 524.771H369.259V526.509H369.85V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.85 528.781H369.259V530.52H369.85V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.76 524.771H371.168V526.509H371.76V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.76 528.781H371.168V530.52H371.76V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.053 524.771H373.462V526.509H374.053V524.771Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.053 528.781H373.462V530.52H374.053V528.781Z",
    fill: "#C9BC8D",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.003 521.905H355.318V522.88H392.003V521.905Z",
    fill: "#979A9F",
    stroke: "#C9BC8D",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.916 504.853H264.492V536.056H277.916V504.853Z",
    fill: "#D8D1C3",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.283 504.125H264.131V504.489H278.283V504.125Z",
    fill: "#095FE7",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.828 504.853H264.584V506.305H277.828V504.853Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.828 522.631H264.584V524.084H277.828V522.631Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.476 504.853H265.944V520.455H271.476V504.853Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.663 533.153H265.944V536.055H270.663V533.153Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.662 533.153H268.121V536.055H270.662V533.153Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.288 533.153H271.569V536.055H276.288V533.153Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.468 533.153H273.927V536.055H276.468V533.153Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.849 525.17H265.944V526.259H267.849V525.17Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.571 525.17H268.666V526.259H270.571V525.17Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.466 525.17H271.84V527.348H276.466V525.17Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.745 525.17H271.84V526.259H273.745V525.17Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.467 525.17H274.562V526.259H276.467V525.17Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.476 507.03H265.944V510.66H271.476V507.03Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.476 512.11H265.944V515.739H271.476V512.11Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.476 516.824H265.944V520.454H271.476V516.824Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.387 507.03H270.299V510.66H271.387V507.03Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.387 512.11H270.299V515.739H271.387V512.11Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.387 516.824H270.299V520.454H271.387V516.824Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.828 521.18H264.584V521.543H277.828V521.18Z",
    fill: "#095FE7",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.466 507.03H274.108V510.66H276.466V507.03Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.466 512.11H274.108V515.739H276.466V512.11Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.466 516.824H274.108V520.454H276.466V516.824Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.467 507.03H275.742V510.66H276.467V507.03Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.467 512.11H275.742V515.739H276.467V512.11Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.467 516.824H275.742V520.454H276.467V516.824Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.663 507.03H267.306V510.66H269.663V507.03Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.663 512.11H267.306V515.739H269.663V512.11Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.663 516.824H267.306V520.454H269.663V516.824Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2172 536.236H61.6526C63.3966 536.236 65.0823 535.572 66.3598 534.378L67.5872 533.234C67.9177 532.923 68.1593 532.531 68.2871 532.095L68.3898 531.754C69.0924 529.365 66.1959 527.574 64.377 529.271V527.979C64.377 525.352 61.075 524.18 59.4199 526.219C60.2114 523.036 56.5567 520.631 53.9491 522.617L53.2243 523.167L53.0215 522.534C52.3217 520.351 49.9529 519.185 47.7923 519.965C45.6512 520.74 44.5709 523.133 45.4096 525.252L45.79 526.219C42.5936 526.219 40.808 529.904 42.7825 532.414L44.2877 534.325C45.2347 535.53 46.687 536.236 48.22 536.236H48.2172Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5282 536.235H60.9194C62.5801 536.235 64.1852 535.632 65.4377 534.541L66.418 533.685C66.7263 533.416 66.954 533.066 67.079 532.675C67.7566 530.531 65.1961 528.826 63.4965 530.303V529.395C63.4965 527.012 60.539 525.907 58.9755 527.704C59.7114 524.946 56.5928 522.783 54.2656 524.435L53.3269 525.104L53.152 524.599C52.4994 522.697 50.4332 521.68 48.5282 522.324C46.5148 523.005 45.5067 525.251 46.3343 527.206L46.5454 527.706C43.7016 527.706 42.1548 531.03 43.9904 533.205L45.2679 534.721C46.076 535.682 47.2701 536.237 48.5309 536.237L48.5282 536.235Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2137 535.355C19.2137 533.806 19.5331 532.275 20.1496 530.856L20.7689 529.435C21.9686 526.674 25.8898 526.674 27.0895 529.435L27.7088 530.856C28.3253 532.275 28.6446 533.806 28.6446 535.355C28.6446 535.741 28.3336 536.055 27.9448 536.055H19.9108C19.522 536.055 19.2109 535.741 19.2109 535.355H19.2137Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4854 535.178C20.4854 533.914 20.7492 532.664 21.2629 531.509L21.5573 530.848C22.682 528.316 26.2755 528.316 27.4002 530.848L27.6946 531.509C28.2056 532.664 28.4722 533.914 28.4722 535.178C28.4722 535.561 28.1612 535.875 27.7751 535.875H21.1852C20.7992 535.875 20.4881 535.564 20.4881 535.178H20.4854Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9297 533.333V536.235",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2874 532.609L23.9297 534.786",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1172 533.696L23.9306 535.693",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0912 536.235H35.4618C36.3949 536.235 37.2891 535.882 37.9723 535.246L38.461 534.788C38.6248 534.638 38.7415 534.449 38.8026 534.238L38.8498 534.083C39.1914 532.93 37.7945 532.061 36.9114 532.88V532.264C36.9114 530.994 35.3146 530.425 34.512 531.411C34.8953 529.878 33.1374 528.715 31.8738 529.67L31.5156 529.942L31.4211 529.639C31.0796 528.587 29.9382 528.023 28.8968 528.398C27.8582 528.773 27.3361 529.931 27.7443 530.956L27.9248 531.411C26.3836 531.411 25.5199 533.191 26.478 534.402L27.2 535.318C27.6582 535.896 28.3525 536.235 29.0912 536.235Z",
    fill: "#259427",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1889 536.055L29.0117 532.609",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4629 534.602L31.732 531.88",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2734 536.235L36.0869 533.877",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0898 533.333L35.359 534.602",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0017 536.055L29.3721 530.067",
    stroke: "#615E66",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.803 547.486H-369.928V551.116H819.803V547.486Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.611 526.988H276.469V536.058H294.611V526.988Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.611 532.427H276.469V536.057H294.611V532.427Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.455 533.93H279.005V536.057H280.455V533.93Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.397 533.93H281.947V536.057H283.397V533.93Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.792 533.93H285.343V536.057H286.792V533.93Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.735 533.93H288.285V536.057H289.735V533.93Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 533.93H291.455V536.057H292.905V533.93Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.455 528.041H279.005V531.301H280.455V528.041Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.397 528.041H281.947V531.301H283.397V528.041Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.792 528.041H285.343V531.301H286.792V528.041Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.735 528.041H288.285V531.301H289.735V528.041Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 528.041H291.455V531.301H292.905V528.041Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.616 522.36L277.01 526.984H294.08L285.616 522.36Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.104 527.531L275.196 526.912L285.727 521.363L295.919 526.912L295.152 527.714L285.538 522.452L276.104 527.531Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.576 542.405L351.18 544.252C354.112 544.577 356.923 543.005 358.178 540.336L358.997 538.598C359.272 538.015 359.397 537.373 359.364 536.732L359.272 535.005C359.086 531.403 354.209 530.442 352.671 533.702L351.818 530.933C350.708 527.32 345.603 527.298 344.459 530.903C343.998 525.762 337.239 524.202 334.573 528.62L333.879 527.523C331.985 524.527 327.88 523.893 325.167 526.176C322.834 528.142 322.406 531.575 324.184 534.055L325.992 536.574C323.487 537.343 323.792 540.978 326.386 541.32L334.573 542.403L334.576 542.405Z",
    fill: "#8AD6C4",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.232 542.404L350.05 544.184C352.966 544.534 355.788 542.995 357.071 540.352L357.643 539.171C357.904 538.635 358.029 538.044 357.998 537.45L357.932 536.039C357.779 532.726 353.308 531.804 351.858 534.784L351.117 532.379C350.098 529.052 345.404 529.005 344.318 532.309C343.924 527.638 337.801 526.169 335.326 530.152L335.229 530.313L334.615 529.355C332.871 526.636 329.145 526.055 326.654 528.113C324.465 529.924 324.063 533.129 325.734 535.425L327.276 537.541C325.096 538.211 325.407 541.39 327.675 541.624L335.226 542.401L335.232 542.404Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.973 542.691L302.708 538.864C300.35 537.623 298.92 535.138 299.028 532.477L299.134 529.989C299.159 529.345 299.345 528.72 299.675 528.164L300.553 526.676C302.388 523.571 307.154 524.976 307.007 528.581L309.042 526.523C311.703 523.835 316.238 526.182 315.58 529.906C318.365 525.562 325.083 527.312 325.399 532.463L326.521 531.813C329.59 530.036 333.519 531.375 334.866 534.654C336.024 537.479 334.811 540.72 332.086 542.091L329.32 543.488H313.186C312.064 543.488 310.961 543.216 309.97 542.694L309.973 542.691Z",
    fill: "#8AD6C4",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.901 541.383L302.554 539.495C300.871 538.142 299.919 536.079 299.983 533.921L300.066 531.128C300.08 530.533 300.246 529.953 300.549 529.439L301.26 528.22C302.929 525.357 307.317 526.607 307.225 529.92L308.991 528.131C311.438 525.657 315.617 527.787 315.051 531.222C317.564 527.265 323.671 528.798 324.018 533.474L324.032 533.663L325.023 533.099C327.825 531.497 331.399 532.711 332.649 535.688C333.749 538.306 332.624 541.331 330.078 542.594L327.731 543.755H315.054L308.308 542.85C307.064 542.683 305.884 542.178 304.903 541.389L304.901 541.383Z",
    fill: "#7CC69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.061 531.146C278.303 529.841 278.55 527.88 277.669 526.309L272.676 517.369C272.19 516.5 270.941 516.5 270.455 517.369L265.317 526.572C264.514 528.005 264.689 529.788 265.753 531.041C266.5 531.921 267.597 532.426 268.755 532.426H274.079C275.206 532.426 276.284 531.963 277.061 531.146Z",
    fill: "#FFD6D0",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.762 531.33C277.959 530.214 278.195 528.403 277.325 527.017L273.16 520.411C272.593 519.508 271.274 519.508 270.708 520.411L265.951 527.959C265.417 528.809 265.529 529.914 266.223 530.642C267.209 531.669 268.569 532.249 269.994 532.249H274.44C275.304 532.249 276.134 531.922 276.767 531.333L276.762 531.33Z",
    fill: "#259427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.568 523.177V536.601",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.848 524.266L271.389 526.807",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.29 527.166L271.749 529.707",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.927 524.266L271.386 526.807",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.313 536.396C287.001 534.877 286.759 532.166 284.835 530.967L281.639 528.978C281.144 528.673 280.517 528.684 280.039 529.012L277.201 530.947C275.365 532.203 275.121 534.816 276.693 536.388C276.715 536.407 276.74 536.418 276.768 536.418H285.251C285.274 536.418 285.296 536.41 285.313 536.393V536.396Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.313 536.393C285.296 536.41 285.274 536.418 285.251 536.418H276.768C276.74 536.418 276.715 536.407 276.693 536.388C275.121 534.816 275.365 532.203 277.201 530.947L280.039 529.012C280.517 528.684 281.144 528.673 281.639 528.978L284.835 530.967C286.759 532.166 287.001 534.877 285.313 536.396V536.393ZM285.313 536.393L285.435 536.529",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.785 536.162C286.887 534.837 286.532 532.838 285.041 531.971L281.464 529.897C281.069 529.669 280.578 529.675 280.189 529.911L277.737 531.408C275.993 532.471 275.868 534.957 277.498 536.19C277.534 536.22 277.581 536.234 277.631 536.234H285.618C285.685 536.234 285.741 536.207 285.785 536.157V536.162Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.365 533.334V536.237",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.008 532.61L281.366 534.787",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.179 533.698L281.365 535.695",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.276 521.723H132.965V536.236H239.276V521.723Z",
    fill: "#D8D0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.988 481.267L242.358 500.315L249.251 500.859L245.985 481.267H245.988Z",
    fill: "#C4C4B3",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.989 481.267L244.72 500.859H249.255L245.989 481.267Z",
    fill: "#CCB45B",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.175 500.859C244.175 500.259 244.661 499.77 245.263 499.77C245.866 499.77 246.352 500.256 246.352 500.859V506.846H244.175V500.859Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.358 500.678C242.358 500.178 242.764 499.77 243.267 499.77C243.769 499.77 244.175 500.175 244.175 500.678V506.846H242.361V500.678H242.358Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.354 501.222C246.354 500.42 247.003 499.77 247.806 499.77C248.608 499.77 249.258 500.42 249.258 501.222V506.846H246.356V501.222H246.354Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.264 506.121C245.264 504.819 246.32 503.764 247.622 503.764C248.925 503.764 249.98 504.819 249.98 506.121V510.112H245.262V506.121H245.264Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.635 505.942C241.635 504.939 242.448 504.128 243.448 504.128C244.448 504.128 245.261 504.942 245.261 505.942V511.929H241.632V505.942H241.635Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.354 506.759C246.354 506.107 246.884 505.579 247.534 505.579H247.714C248.364 505.579 248.895 506.107 248.895 506.759C248.895 507.412 248.364 507.94 247.714 507.94H247.534C246.884 507.94 246.354 507.412 246.354 506.759Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.723 507.03C242.723 506.63 243.05 506.305 243.447 506.305C243.845 506.305 244.172 506.63 244.172 507.03V507.574C244.172 507.974 243.845 508.299 243.447 508.299C243.05 508.299 242.723 507.974 242.723 507.574V507.03Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.267 515.376L248.89 508.3L261.409 515.376H243.267Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.891 508.3L238.005 513.743L238.369 514.107V517.372L243.267 515.559L248.891 508.303V508.3Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.226 536.6V515.375H243.447L238.368 517.372V536.603H261.226V536.6Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.368 521.905H133.87V536.418H238.368V521.905Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.871 515.737V521.905H238.369V513.923H132.44L133.829 515.623L133.868 515.673V515.737H133.871Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.124 460.948H183.399C183.098 460.948 182.854 461.192 182.854 461.493V514.829C182.854 515.129 183.098 515.373 183.399 515.373H184.124C184.424 515.373 184.668 515.129 184.668 514.829V461.493C184.668 461.192 184.424 460.948 184.124 460.948Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.478 460.948H187.753C187.453 460.948 187.209 461.192 187.209 461.493V514.829C187.209 515.129 187.453 515.373 187.753 515.373H188.478C188.779 515.373 189.022 515.129 189.022 514.829V461.493C189.022 461.192 188.779 460.948 188.478 460.948Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.676 526.987H134.597V536.421H139.676V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.676 526.987H134.597V528.801H139.676V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.685 522.993H134.597V525.534H135.685V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.864 522.993H136.411V525.534H137.864V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.677 522.993H138.588V525.534H139.677V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.022 526.987H142.942V536.421H148.022V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.031 522.993H142.942V525.534H144.031V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.209 522.993H144.757V525.534H146.209V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.022 522.993H146.934V525.534H148.022V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.987 526.987H158.908V536.421H163.987V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.997 522.993H158.908V525.534H159.997V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.175 522.993H160.723V525.534H162.175V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.987 522.993H162.898V525.534H163.987V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.332 526.987H167.253V536.421H172.332V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.342 522.993H167.253V525.534H168.342V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.519 522.993H169.066V525.534H170.519V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.333 522.993H171.244V525.534H172.333V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.677 526.987H175.598V536.421H180.677V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.686 522.993H175.598V525.534H176.686V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.864 522.993H177.411V525.534H178.864V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.678 522.993H179.589V525.534H180.678V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.004 526.987H191.925V536.421H197.004V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.013 522.993H191.925V525.534H193.013V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.193 522.993H193.74V525.534H195.193V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.004 522.993H195.915V525.534H197.004V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35 526.987H200.271V536.421H205.35V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.359 522.993H200.271V525.534H201.359V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.538 522.993H202.086V525.534H203.538V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.352 522.993H204.264V525.534H205.352V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.644 526.987H232.564V536.421H237.644V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.653 522.993H232.564V525.534H233.653V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.83 522.993H234.378V525.534H235.83V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.167 529.888H245.989V536.42H248.167V529.888Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.722 530.249H241.634V534.24H242.722V530.249Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.546 530.249H239.457V534.24H240.546V530.249Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.634 528.436H242.722V524.132L241.634 524.404V528.436Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.457 528.435H240.546V524.495L239.457 524.767V528.435Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.634 518.6V521.338L242.722 521.202V518.328L241.634 518.6Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.457 518.962V521.7L240.546 521.564V518.69L239.457 518.962Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.052 530.249H256.875V534.24H259.052V530.249Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.643 522.993H236.555V525.534H237.643V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.298 526.987H224.219V536.421H229.298V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.307 522.993H224.219V525.534H225.307V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.485 522.993H226.032V525.534H227.485V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3 522.993H228.211V525.534H229.3V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.694 526.987H208.615V536.421H213.694V526.987Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.704 522.993H208.615V525.534H209.704V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.883 522.993H210.431V525.534H211.883V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.696 522.993H212.607V525.534H213.696V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.837 520.454H230.023V536.419H231.837V520.454Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.889 520.454H206.075V536.419H207.889V520.454Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.544 520.454H197.73V536.419H199.544V520.454Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87 520.454H173.057V536.419H174.87V520.454Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.526 520.454H164.713V536.419H166.526V520.454Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.215 520.454H140.401V536.419H142.215V520.454Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.111 522.087C149.111 519.582 151.144 517.552 153.646 517.552C156.148 517.552 158.181 519.582 158.181 522.087V536.419H149.111V522.087Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.422 522.087C214.422 519.582 216.455 517.552 218.957 517.552C221.459 517.552 223.492 519.582 223.492 522.087V536.419H214.422V522.087Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.448 514.286C243.448 513.886 243.776 513.562 244.173 513.562C244.57 513.562 244.898 513.886 244.898 514.286V536.6H243.445V514.286H243.448Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.236 518.64C257.236 518.24 257.564 517.915 257.961 517.915C258.358 517.915 258.686 518.24 258.686 518.64V520.998H257.233V518.64H257.236Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.352 518.64C246.352 518.24 246.68 517.915 247.077 517.915C247.474 517.915 247.802 518.24 247.802 518.64V520.998H246.35V518.64H246.352Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.989 524.444C245.989 523.844 246.475 523.355 247.078 523.355C247.68 523.355 248.167 523.841 248.167 524.444V527.89H245.989V524.444Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.875 524.444C256.875 523.844 257.361 523.355 257.964 523.355C258.566 523.355 259.052 523.841 259.052 524.444V527.89H256.875V524.444Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.767 520.271C181.767 517.766 183.799 515.736 186.302 515.736C188.804 515.736 190.836 517.766 190.836 520.271V536.417H181.767V520.271Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.87 536.421V519.911L129.515 519.003H112.825V536.418H133.87V536.421Z",
    fill: "#D8D0C3",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.733 519.002L125.344 510.837L129.699 519.002H113.733Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.518 518.822L125.527 511.021L132.42 514.106L133.872 515.739V520.094L129.518 518.825V518.822Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73 533.516H117.908V527.712C117.908 527.112 117.422 526.624 116.819 526.624C116.216 526.624 115.73 527.11 115.73 527.712V533.516Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.091 524.082H117.543V522.269C117.543 521.869 117.216 521.544 116.818 521.544C116.421 521.544 116.094 521.869 116.094 522.269V524.082H116.091Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.524 524.082H126.977V522.269C126.977 521.869 126.649 521.544 126.252 521.544C125.855 521.544 125.527 521.869 125.527 522.269V524.082H125.524Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.164 533.516H127.341V527.712C127.341 527.112 126.855 526.624 126.253 526.624C125.65 526.624 125.164 527.11 125.164 527.712V533.516Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.357 518.822C119.357 517.519 120.413 516.464 121.715 516.464C123.017 516.464 124.073 517.519 124.073 518.822V536.42H119.354V518.822H119.357Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.825 517.37C112.825 516.87 113.231 516.462 113.733 516.462C114.236 516.462 114.641 516.867 114.641 517.37V536.418H112.828V517.37H112.825Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.431 517.189C128.431 516.789 128.758 516.464 129.155 516.464C129.552 516.464 129.88 516.789 129.88 517.189V536.42H128.428V517.189H128.431Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.811 524.082H122.263V522.269C122.263 521.869 121.935 521.544 121.538 521.544C121.141 521.544 120.813 521.869 120.813 522.269V524.082H120.811Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445 533.516H122.986V527.893C122.986 527.19 122.417 526.624 121.717 526.624C121.017 526.624 120.448 527.193 120.448 527.893V533.516H120.445Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.836 522.448C149.836 520.343 151.541 518.638 153.646 518.638C155.751 518.638 157.456 520.343 157.456 522.448V536.417H149.836V522.448Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.924 536.421H156.003V529.528C156.003 528.126 154.867 526.987 153.462 526.987C152.057 526.987 150.921 528.123 150.921 529.528V536.421H150.924Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.013 522.993H150.925V525.534H152.013V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19 522.993H152.737V525.534H154.19V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.003 522.993H154.914V525.534H156.003V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.146 522.448C215.146 520.343 216.852 518.638 218.957 518.638C221.062 518.638 222.767 520.343 222.767 522.448V536.417H215.146V522.448Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.49 520.634C182.49 518.529 184.195 516.824 186.3 516.824C188.405 516.824 190.11 518.529 190.11 520.634V536.419H182.49V520.634Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.58 536.421H188.659V529.528C188.659 528.126 187.523 526.987 186.118 526.987C184.713 526.987 183.577 528.123 183.577 529.528V536.421H183.58Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.668 522.993H183.579V525.534H184.668V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.847 522.993H185.395V525.534H186.847V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.659 522.993H187.57V525.534H188.659V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.234 536.421H221.313V529.528C221.313 528.126 220.178 526.987 218.772 526.987C217.367 526.987 216.231 528.123 216.231 529.528V536.421H216.234Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.234 536.42H221.313V530.977C221.313 529.575 220.178 528.436 218.772 528.436C217.367 528.436 216.231 529.572 216.231 530.977V536.42H216.234Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.58 536.42H188.659V530.977C188.659 529.575 187.523 528.436 186.118 528.436C184.713 528.436 183.577 529.572 183.577 530.977V536.42H183.58Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.924 536.42H156.003V530.977C156.003 529.575 154.867 528.436 153.462 528.436C152.057 528.436 150.921 529.572 150.921 530.977V536.42H150.924Z",
    fill: "#F5B834",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.324 522.993H216.235V525.534H217.324V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.501 522.993H218.049V525.534H219.501V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.314 522.993H220.226V525.534H221.314V522.993Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.255 515.919C249.255 514.014 250.796 512.473 252.701 512.473C254.606 512.473 256.148 514.017 256.148 515.919V536.6H249.255V515.919Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.334 530.249H251.432V534.24H254.334V530.249Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.705 518.64C250.705 518.24 251.033 517.915 251.43 517.915C251.827 517.915 252.155 518.24 252.155 518.64V520.998H250.702V518.64H250.705Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.245 518.64C253.245 518.24 253.573 517.915 253.97 517.915C254.367 517.915 254.695 518.24 254.695 518.64V520.998H253.242V518.64H253.245Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.431 524.625C251.431 523.922 252.001 523.355 252.701 523.355C253.4 523.355 253.97 523.925 253.97 524.625V527.89H251.429V524.625H251.431Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.022 526.987H142.942V528.801H148.022V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.987 526.987H158.908V528.801H163.987V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.332 526.987H167.253V528.801H172.332V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.677 526.987H175.598V528.801H180.677V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.004 526.987H191.925V528.801H197.004V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35 526.987H200.271V528.801H205.35V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.694 526.987H208.615V528.801H213.694V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.298 526.987H224.219V528.801H229.298V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.644 526.987H232.564V528.801H237.644V526.987Z",
    fill: "#6017CD",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.138 514.286C260.138 513.886 260.465 513.562 260.862 513.562C261.26 513.562 261.587 513.886 261.587 514.286V536.6H260.135V514.286H260.138Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6713 521.544H-19.4619V536.057H2.6713V521.544Z",
    fill: "white",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.31934 525.898H2.31027V530.616H-1.31934V525.898Z",
    fill: "#FFF9DE",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6713 521.544H-19.4619V536.057H2.6713V521.544Z",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6713 521.544H-19.4619V523.357H2.6713V521.544Z",
    fill: "#095FE7",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.802 536.056H-369.748V547.303H819.802V536.056Z",
    fill: "#E1F1F1",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.803 536.108H-369.928V547.123H819.803V536.108Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.038 542.043C305.935 543.073 305.069 543.856 304.036 543.856H303.772C302.706 543.856 301.795 543.093 301.609 542.043C301.442 543.087 300.528 543.856 299.468 543.856C298.404 543.856 297.479 543.09 297.293 542.043C297.104 543.093 296.191 543.856 295.124 543.856H294.983C293.916 543.856 293.005 543.093 292.819 542.043L292.753 542.351C292.564 543.232 291.786 543.859 290.886 543.859H290.795C289.792 543.859 288.981 543.045 288.981 542.046",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M131.948 550.327C129.576 549.536 127.771 550.658 127.169 551.316C126.946 551.424 126.474 551.547 126.344 551.152C127.66 549.669 130.298 549.175 131.945 550.327H131.948Z",
    fill: "url(#paint5_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.97 541.524C212.97 539.975 213.289 538.444 213.905 537.025L214.525 535.604C215.724 532.843 219.646 532.843 220.845 535.604L221.465 537.025C222.081 538.444 222.4 539.975 222.4 541.524C222.4 541.91 222.089 542.224 221.701 542.224H213.667C213.278 542.224 212.967 541.91 212.967 541.524H212.97Z",
    fill: "#E1F1F1",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.242 541.346C214.242 540.083 214.506 538.833 215.02 537.678L215.314 537.017C216.439 534.484 220.032 534.484 221.157 537.017L221.452 537.678C221.962 538.833 222.229 540.083 222.229 541.346C222.229 541.729 221.918 542.043 221.532 542.043H214.942C214.556 542.043 214.245 541.732 214.245 541.346H214.242Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 539.502V542.404",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.045 538.778L217.688 540.955",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.875 539.867L217.688 541.863",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.884 542.199C187.196 540.68 187.437 537.97 189.362 536.77L192.558 534.782C193.053 534.476 193.68 534.487 194.158 534.815L196.996 536.751C198.832 538.006 199.076 540.619 197.504 542.191C197.482 542.21 197.457 542.221 197.429 542.221H188.945C188.923 542.221 188.901 542.213 188.884 542.196V542.199Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.884 542.196C188.901 542.213 188.923 542.221 188.945 542.221H197.429C197.457 542.221 197.482 542.21 197.504 542.191C199.076 540.619 198.832 538.006 196.996 536.751L194.158 534.815C193.68 534.487 193.053 534.476 192.558 534.782L189.362 536.77C187.437 537.97 187.196 540.68 188.884 542.199V542.196ZM188.884 542.196L188.762 542.332",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14 541.967C188.037 540.642 188.393 538.643 189.884 537.776L193.461 535.702C193.855 535.474 194.347 535.48 194.736 535.716L197.188 537.212C198.932 538.276 199.057 540.762 197.427 541.995C197.391 542.025 197.343 542.039 197.293 542.039H189.307C189.24 542.039 189.184 542.011 189.14 541.961V541.967Z",
    fill: "#259427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.833 539.142V542.044",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.191 538.414L192.833 540.591",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.02 539.502L192.833 541.499",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.848 542.405H229.219C230.152 542.405 231.046 542.052 231.729 541.416L232.218 540.958C232.382 540.808 232.498 540.619 232.559 540.408L232.607 540.252C232.948 539.1 231.551 538.231 230.668 539.05V538.434C230.668 537.164 229.071 536.595 228.269 537.581C228.652 536.048 226.894 534.884 225.631 535.84L225.272 536.112L225.178 535.809C224.836 534.757 223.695 534.193 222.654 534.568C221.615 534.943 221.093 536.101 221.501 537.126L221.682 537.581C220.14 537.581 219.277 539.361 220.235 540.572L220.957 541.488C221.415 542.066 222.109 542.405 222.848 542.405Z",
    fill: "#259427",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.945 542.224L222.768 538.778",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.219 540.772L225.488 538.05",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.027 542.404L229.841 540.046",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.847 539.502L229.116 540.772",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.759 542.224L223.129 536.237",
    stroke: "#6017CD",
    strokeWidth: 0.277707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.978 534.423C169.228 534.423 169.433 534.626 169.433 534.878V542.16C169.433 542.41 169.231 542.615 168.978 542.615C168.728 542.615 168.522 542.412 168.522 542.16V534.878C168.522 534.628 168.725 534.423 168.978 534.423Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.905 535.028H169.434V538.061H184.905V535.028Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.905 537.152H169.434V537.455H184.905V537.152Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.905 535.939H169.434V536.242H184.905V535.939Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.993 534.878C183.993 534.626 184.196 534.423 184.446 534.423C184.696 534.423 184.904 534.626 184.904 534.878V542.16C184.904 542.41 184.701 542.615 184.446 542.615C184.19 542.615 183.993 542.412 183.993 542.16V534.878Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.405 539.58C171.655 539.58 171.86 539.782 171.86 540.035V542.765C171.86 543.015 171.657 543.22 171.405 543.22C171.155 543.22 170.949 543.018 170.949 542.765V540.035C170.949 539.785 171.152 539.58 171.405 539.58Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.571 539.58C186.821 539.58 187.026 539.782 187.026 540.035V542.765C187.026 543.015 186.823 543.22 186.571 543.22C186.321 543.22 186.115 543.018 186.115 542.765V540.035C186.115 539.785 186.318 539.58 186.571 539.58Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.433 539.58L168.522 538.822H184.904L187.026 539.58V540.491H170.95L169.433 539.58Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.028 539.58H170.949V540.49H187.028V539.58Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.522 538.822L170.95 539.58V540.793L168.522 539.733V538.822Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.025 535.616C246.85 535.616 246.706 535.758 246.706 535.935V541.044C246.706 541.219 246.848 541.363 247.025 541.363C247.201 541.363 247.345 541.221 247.345 541.044V535.935C247.345 535.76 247.203 535.616 247.025 535.616Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.852 536.04H246.706V538.168H235.852V536.04Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.852 537.531H246.706V537.743H235.852V537.531Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.852 536.68H246.706V536.892H235.852V536.68Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.491 535.935C236.491 535.758 236.349 535.616 236.174 535.616C235.998 535.616 235.852 535.758 235.852 535.935V541.044C235.852 541.219 235.994 541.363 236.174 541.363C236.353 541.363 236.491 541.221 236.491 541.044V535.935Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.322 539.233C245.147 539.233 245.003 539.376 245.003 539.553V541.468C245.003 541.643 245.145 541.788 245.322 541.788C245.497 541.788 245.642 541.645 245.642 541.468V539.553C245.642 539.378 245.499 539.233 245.322 539.233Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.682 539.233C234.507 539.233 234.363 539.376 234.363 539.553V541.468C234.363 541.643 234.505 541.788 234.682 541.788C234.858 541.788 235.002 541.645 235.002 541.468V539.553C235.002 539.378 234.86 539.233 234.682 539.233Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.705 539.235L247.344 538.703H235.851L234.362 539.235V539.874H245.641L246.705 539.235Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.361 539.233H245.642V539.872H234.361V539.233Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.344 538.703L245.641 539.235V540.086L247.344 539.342V538.703Z",
    fill: "#6017CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.803 568.892H-369.928V573.21H819.803V568.892Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.803 572.824H-369.928V575.784H819.803V572.824Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8673 538.778C12.7618 539.405 12.2175 539.866 11.5815 539.866H9.89028C9.21546 539.866 8.62395 539.422 8.4351 538.778C8.2657 539.419 7.68805 539.866 7.02433 539.866H5.57749C4.90267 539.866 4.31116 539.422 4.12232 538.778C3.9307 539.425 3.33362 539.866 2.6588 539.866H1.10087C0.426042 539.866 -0.16547 539.422 -0.354311 538.778C-0.587584 539.43 -1.20688 539.866 -1.8956 539.866H-3.10083C-3.70345 539.866 -4.18945 539.38 -4.18945 538.778",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.365 538.778C117.26 539.405 116.716 539.866 116.08 539.866H114.388C113.713 539.866 113.122 539.422 112.933 538.778C112.764 539.419 112.186 539.866 111.522 539.866H110.076C109.401 539.866 108.809 539.422 108.62 538.778C108.429 539.425 107.832 539.866 107.157 539.866H105.599C104.924 539.866 104.333 539.422 104.144 538.778C103.91 539.43 103.291 539.866 102.602 539.866H101.397C100.795 539.866 100.309 539.38 100.309 538.778",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.336 542.044C88.2333 543.074 87.3668 543.857 86.3338 543.857H86.0699C85.0036 543.857 84.0927 543.094 83.9066 542.044C83.74 543.088 82.8263 543.857 81.7655 543.857C80.7019 543.857 79.7771 543.091 79.5911 542.044C79.4022 543.094 78.4886 543.857 77.4222 543.857H77.2805C76.2141 543.857 75.3033 543.094 75.1172 542.044L75.0505 542.352C74.8617 543.233 74.0841 543.86 73.1844 543.86H73.0927C72.0902 543.86 71.2793 543.046 71.2793 542.047",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.068 538.778C334.963 539.405 334.419 539.866 333.783 539.866H332.091C331.417 539.866 330.825 539.422 330.636 538.778C330.467 539.419 329.889 539.866 329.225 539.866H327.779C327.104 539.866 326.512 539.422 326.323 538.778C326.132 539.425 325.535 539.866 324.86 539.866H323.302C322.627 539.866 322.036 539.422 321.847 538.778C321.614 539.43 320.994 539.866 320.306 539.866H319.1C318.498 539.866 318.012 539.38 318.012 538.778",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.164 515.376C86.569 515.376 88.5184 517.325 88.5184 519.73V525.173C88.5184 527.578 86.569 529.528 84.164 529.528C81.7591 529.528 79.8096 527.578 79.8096 525.173V519.73C79.8096 517.325 81.7591 515.376 84.164 515.376Z",
    fill: "#E1F1F1",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7077 516.645C86.7128 516.645 88.3374 518.269 88.3374 520.274V525.353C88.3374 527.358 86.7128 528.983 84.7077 528.983C82.7027 528.983 81.0781 527.358 81.0781 525.353V520.274C81.0781 518.269 82.7027 516.645 84.7077 516.645Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9805 520.271V536.237",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.701 521.36L83.9795 524.387",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.623 524.266L83.9808 526.623",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.623 521.36L83.9808 523.718",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2246 521.906C99.6295 521.906 101.579 523.855 101.579 526.26C101.579 528.665 99.6295 530.615 97.2246 530.615C94.8196 530.615 92.8701 528.665 92.8701 526.26C92.8701 523.855 94.8196 521.906 97.2246 521.906Z",
    fill: "#E1F1F1",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2237 523.538H97.5875C99.4925 523.538 101.034 525.082 101.034 526.984C101.034 528.889 99.4898 530.431 97.5875 530.431H97.2237C95.3186 530.431 93.7773 528.887 93.7773 526.984C93.7773 525.079 95.3214 523.538 97.2237 523.538Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0439 526.804V536.057",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.582 527.167L97.041 529.708",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6855 527.167L97.2266 529.708",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4471 536.057C72.4471 536.057 72.3833 535.979 72.3527 535.94C71.1475 534.383 71.5085 532.055 73.2553 530.967L76.4517 528.978C76.946 528.673 77.5736 528.684 78.0512 529.012L80.8894 530.947C82.5473 532.08 82.9056 534.321 81.8031 535.904C81.767 535.954 81.692 536.057 81.692 536.057H72.4499H72.4471Z",
    fill: "#E1F1F1",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0219 535.843C71.9333 534.535 72.2832 532.563 73.7551 531.708L77.2847 529.661C77.6763 529.436 78.1595 529.442 78.5399 529.675L80.9588 531.152C82.6805 532.202 82.8027 534.654 81.1948 535.871C81.1587 535.898 81.1115 535.915 81.0615 535.915H73.183C73.1191 535.915 73.0608 535.887 73.0191 535.84L73.0219 535.843Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7236 533.335V536.056",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0814 532.61L76.7236 534.787",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9102 533.699L76.7236 535.696",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5336 536.057C96.5336 536.057 96.9363 535.782 97.1168 535.613L97.6056 535.155C97.7694 535.005 97.886 534.816 97.9471 534.605L97.9944 534.449C98.3359 533.297 96.939 532.428 96.0559 533.247V532.63C96.0559 531.361 94.4591 530.792 93.6565 531.778C94.0398 530.245 92.2819 529.081 91.0183 530.037L90.6601 530.309L90.5657 530.006C90.2241 528.953 89.0827 528.39 88.0413 528.765C87.0027 529.14 86.4806 530.298 86.8888 531.322L87.0694 531.778C85.5281 531.778 84.6644 533.558 85.6225 534.769L86.3446 535.685C86.4529 535.824 86.7111 536.057 86.7111 536.057H96.5336Z",
    fill: "#AACAC9",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1 536.057L88.1533 532.972",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.335 534.843L90.8762 532.247",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.834 536.058L95.2309 534.244",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2324 533.699L94.621 535.032",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.925 536.059L88.5176 530.435",
    stroke: "#6017CD",
    strokeWidth: 0.277707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.049 536.132V509.679H310.867L321.542 503.412L332.682 507.821L345.91 499.931L348.464 536.132H205.052H205.049Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.834 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.619 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.399 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.185 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.971 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.753 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.539 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.323 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.109 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.896 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.681 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.464 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.248 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.033 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.604 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.387 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.171 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.956 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.741 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.525 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.095 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.882 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.665 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.451 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.233 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.02 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.805 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.59 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.375 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.157 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.942 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.728 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.511 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.296 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.082 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.866 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.652 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.438 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.223 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.006 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.577 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.362 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.146 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.928 513.389V536.131",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.713 512.695V536.133",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.497 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.282 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.067 511.535V536.135",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.279 501.554C200.267 501.739 192.669 499.931 189.5 499C201.336 511.067 203.19 513.387 205.279 514.548C215.027 515.475 212.703 513.156 225.236 513.156C237.768 513.156 244.731 516.406 251.228 516.637C257.725 516.868 259.348 513.156 267.241 513.156C275.134 513.156 279.308 518.495 284.647 518.495C289.986 518.495 289.752 512.925 296.945 512.694C304.139 512.463 307.389 519.887 310.87 519.887C317.602 519.887 314.12 512.229 320.848 511.998C327.58 511.767 327.346 520.814 331.754 520.814C336.162 520.814 335.931 512.229 341.501 511.532C347.071 510.836 346.84 531.027 348.464 535.897C352.872 523.134 354.961 499 348.464 499C341.967 499 342.428 513.156 336.862 513.387C331.292 513.618 334.773 501.551 327.349 500.623C319.925 499.696 319.925 511.067 314.121 511.529C308.32 511.994 309.478 500.623 301.357 500.623C293.237 500.623 292.306 509.209 286.04 509.209C279.774 509.209 277.919 500.623 267.241 500.623C260.048 500.623 256.336 505.962 249.835 505.962C243.335 505.962 235.981 500.755 227.094 499.927C217.115 499 211.545 501.32 205.279 501.551V501.554Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.105 511.766C348.087 496.172 349.004 521.048 348.46 535.435C346.837 517.333 345.21 515.432 344.283 513.39C343.121 510.836 341.498 511.532 340.105 511.766Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.279 522.21H207.833",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.279 529.635H207.833",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.399 518.494H215.954",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.399 525.923H215.954",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.399 533.346H215.954",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.971 518.494H221.525",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.971 525.923H221.525",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.971 533.346H221.525",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.539 518.494H227.093",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.539 525.923H227.093",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.539 533.346H227.093",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.109 518.494H232.663",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.109 525.923H232.663",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.109 533.346H232.663",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.681 518.494H238.235",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.681 525.923H238.235",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.681 533.346H238.235",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.248 518.494H243.802",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.248 525.923H243.802",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.248 533.346H243.802",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82 518.494H249.374",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82 525.923H249.374",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82 533.346H249.374",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.387 518.494H254.941",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.387 525.923H254.941",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.387 533.346H254.941",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.956 518.494H260.51",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.956 525.923H260.51",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.956 533.346H260.51",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.525 518.494H266.079",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.525 525.923H266.079",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.525 533.346H266.079",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.095 518.494H271.649",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.095 525.923H271.649",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.095 533.346H271.649",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.665 518.494H277.219",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.665 525.923H277.219",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.665 533.346H277.219",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.233 518.494H282.787",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.233 525.923H282.787",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.233 533.346H282.787",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.805 518.494H288.359",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.805 525.923H288.359",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.805 533.346H288.359",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.375 518.494H293.929",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.375 525.923H293.929",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.375 533.346H293.929",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.942 518.494H299.496",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.942 525.923H299.496",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.942 533.346H299.496",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.511 518.494H305.065",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.511 525.923H305.065",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.511 533.346H305.065",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.223 518.494H321.777",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.223 525.923H321.777",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.223 533.346H321.777",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 518.494H327.345",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 525.923H327.345",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 533.346H327.345",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.928 518.494H338.482",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.928 525.923H338.482",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.928 533.346H338.482",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.082 525.923H310.636",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.082 533.346H310.636",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.652 525.923H316.206",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.652 533.346H316.206",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.062 518.494H210.617",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.062 525.923H210.617",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.062 533.346H210.617",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.849 522.21H213.403",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.849 529.635H213.403",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.419 522.21H218.973",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.419 529.635H218.973",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.989 522.21H224.543",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.989 529.635H224.543",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.555 522.21H230.109",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.555 529.635H230.109",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.125 522.21H235.679",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.125 529.635H235.679",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.695 522.21H241.249",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.695 529.635H241.249",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.265 522.21H246.819",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.265 529.635H246.819",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.835 522.21H252.389",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.835 529.635H252.389",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.404 522.21H257.958",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.404 529.635H257.958",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.976 522.21H263.53",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.976 529.635H263.53",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.541 522.21H269.095",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.541 529.635H269.095",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11 522.21H274.664",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11 529.635H274.664",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.681 522.21H280.235",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.681 529.635H280.235",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.252 522.21H285.806",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.252 529.635H285.806",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.821 522.21H291.375",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.821 529.635H291.375",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.391 522.21H296.945",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.391 529.635H296.945",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.962 522.21H302.516",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.962 529.635H302.516",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.531 522.21H308.085",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.531 529.635H308.085",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.098 522.21H313.652",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.098 529.635H313.652",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.667 522.21H319.221",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.667 529.635H319.221",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.237 522.21H324.791",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.237 529.635H324.791",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.807 522.21H330.361",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.807 529.635H330.361",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.375 522.21H335.929",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.375 529.635H335.929",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.947 522.21H341.501",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.947 529.635H341.501",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.518 522.21H346.606",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.518 529.635H347.072",
    stroke: "#615E66",
    strokeWidth: 0.355226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.415 511.766C324.685 510.179 319.918 509.678 317.133 513.39C321.776 510.14 324.07 512.512 325.488 514.086C327.576 516.406 327.576 521.201 332.219 520.583C328.042 517.102 329.203 514.317 326.418 511.766H326.415Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 511.908C301.091 510.153 293.695 510.373 290.214 515.478C294.622 511.301 299.588 512.917 301.585 513.62C305.531 515.013 306.689 520.274 311.332 519.656C307.688 518.728 307.361 514.462 303.645 511.908Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.504 511.768C270.523 510.915 264.687 511.072 257.725 515.249C265.845 511.999 270.811 513.153 272.808 513.857C276.754 515.249 279.539 518.034 284.409 518.265C280.765 517.338 278.374 513.16 273.504 511.768Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.822 511.301C228.948 510.836 222.441 510.623 211.546 514.551C223.382 512.232 229.94 513.18 233.126 513.39C239.392 513.802 243.602 516.42 251.228 516.64C245.53 515.766 241.527 512.036 233.822 511.301Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.045 527.312C374.894 527.312 393.417 508.789 393.417 485.94C393.417 463.09 374.894 444.567 352.045 444.567C329.195 444.567 310.672 463.09 310.672 485.94C310.672 508.789 329.195 527.312 352.045 527.312ZM352.045 523.811C372.96 523.811 389.915 506.855 389.915 485.94C389.915 465.024 372.96 448.069 352.045 448.069C331.129 448.069 314.174 465.024 314.174 485.94C314.174 506.855 331.129 523.811 352.045 523.811Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.044 508.049C364.255 508.049 374.153 498.248 374.153 486.158C374.153 474.068 364.255 464.267 352.044 464.267C339.834 464.267 329.936 474.068 329.936 486.158C329.936 498.248 339.834 508.049 352.044 508.049ZM352.044 504.986C362.563 504.986 371.09 496.559 371.09 486.161C371.09 475.764 362.563 467.336 352.044 467.336C341.526 467.336 332.998 475.764 332.998 486.161C332.998 496.559 341.526 504.986 352.044 504.986Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.045 527.312C374.894 527.312 393.417 508.789 393.417 485.94C393.417 463.09 374.894 444.567 352.045 444.567C329.195 444.567 310.672 463.09 310.672 485.94C310.672 508.789 329.195 527.312 352.045 527.312Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.48 523.81V527.312",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.819 523.155L344.162 526.439",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.045 523.811C372.96 523.811 389.916 506.855 389.916 485.94C389.916 465.024 372.96 448.069 352.045 448.069C331.129 448.069 314.174 465.024 314.174 485.94C314.174 506.855 331.129 523.811 352.045 523.811Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.045 519.435C370.542 519.435 385.537 504.538 385.537 486.161C385.537 467.785 370.542 452.888 352.045 452.888C333.548 452.888 318.554 467.785 318.554 486.161C318.554 504.538 333.548 519.435 352.045 519.435Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.045 515.055C367.882 515.055 380.721 502.119 380.721 486.161C380.721 470.203 367.882 457.267 352.045 457.267C336.207 457.267 323.368 470.203 323.368 486.161C323.368 502.119 336.207 515.055 352.045 515.055Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.044 511.556C365.947 511.556 377.219 500.187 377.219 486.163C377.219 472.139 365.947 460.771 352.044 460.771C338.14 460.771 326.869 472.139 326.869 486.163C326.869 500.187 338.14 511.556 352.044 511.556Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.044 508.053C364.255 508.053 374.153 498.252 374.153 486.162C374.153 474.072 364.255 464.271 352.044 464.271C339.834 464.271 329.936 474.072 329.936 486.162C329.936 498.252 339.834 508.053 352.044 508.053Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.045 504.987C362.564 504.987 371.091 496.559 371.091 486.162C371.091 475.765 362.564 467.337 352.045 467.337C341.526 467.337 332.999 475.765 332.999 486.162C332.999 496.559 341.526 504.987 352.045 504.987Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.043 497.983C358.693 497.983 364.083 492.69 364.083 486.161C364.083 479.632 358.693 474.339 352.043 474.339C345.394 474.339 340.004 479.632 340.004 486.161C340.004 492.69 345.394 497.983 352.043 497.983Z",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.655 530.157H375.467C374.941 529.282 375.249 528.187 375.467 527.748H377.655C378.181 528.8 377.873 529.792 377.655 530.157Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.586 532.786H365.397C364.871 531.911 365.18 530.815 365.397 530.376H367.586C368.112 531.429 367.803 532.42 367.586 532.786Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39 534.538H356.202C355.676 533.663 355.984 532.567 356.202 532.128H358.39C358.916 533.181 358.608 534.172 358.39 534.538Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.761 534.538H346.573C346.047 533.663 346.355 532.567 346.573 532.128H348.761C349.287 533.181 348.979 534.172 348.761 534.538Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.005 533.224H337.816C337.29 532.349 337.599 531.253 337.816 530.814H340.005C340.531 531.867 340.222 532.858 340.005 533.224Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.781 446.103H374.593C374.067 445.228 374.375 444.132 374.593 443.693H376.781C377.307 444.746 376.999 445.737 376.781 446.103Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.586 442.597H365.397C364.871 441.722 365.18 440.626 365.397 440.188H367.586C368.112 441.24 367.803 442.231 367.586 442.597Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.516 440.409H355.328C354.802 439.535 355.11 438.439 355.328 438H357.516C358.042 439.052 357.734 440.044 357.516 440.409Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.448 440.848H345.26C344.734 439.974 345.042 438.878 345.26 438.439H347.448C347.974 439.491 347.666 440.483 347.448 440.848Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.378 443.036H335.189C334.663 442.162 334.972 441.066 335.189 440.627H337.378C337.904 441.679 337.595 442.671 337.378 443.036Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.623 446.976H326.435C325.909 446.102 326.217 445.006 326.435 444.567H328.623C329.149 445.619 328.84 446.611 328.623 446.976Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.302 453.106H318.114C317.588 452.231 317.896 451.136 318.114 450.697H320.302C320.828 451.749 320.52 452.741 320.302 453.106Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.734 460.547H311.546C311.02 459.673 311.328 458.577 311.546 458.138H313.734C314.26 459.19 313.952 460.182 313.734 460.547Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.483 469.742H306.295C305.769 468.868 306.077 467.772 306.295 467.333H308.483C309.009 468.385 308.701 469.377 308.483 469.742Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.857 478.937H303.669C303.143 478.063 303.451 476.967 303.669 476.528H305.857C306.383 477.58 306.075 478.572 305.857 478.937Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.978 489.007H302.79C302.264 488.133 302.572 487.037 302.79 486.598H304.978C305.504 487.65 305.196 488.642 304.978 489.007Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.857 499.076H303.669C303.143 498.201 303.451 497.105 303.669 496.667H305.857C306.383 497.719 306.075 498.711 305.857 499.076Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.919 508.705H306.73C306.204 507.831 306.513 506.735 306.73 506.296H308.919C309.445 507.348 309.136 508.34 308.919 508.705Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.173 517.461H311.985C311.459 516.587 311.768 515.491 311.985 515.052H314.173C314.7 516.104 314.391 517.096 314.173 517.461Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.18 524.907H318.992C318.466 524.033 318.774 522.937 318.992 522.498H321.18C321.706 523.55 321.398 524.542 321.18 524.907Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.496 530.597H327.308C326.782 529.723 327.09 528.627 327.308 528.188H329.496C330.022 529.24 329.714 530.232 329.496 530.597Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.955 459.456L351.605 485.944",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74 452.23L351.605 485.94",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.622 446.759L351.605 485.722",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.378 443.036L351.827 485.722",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.789 440.849L351.825 485.723",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.202 440.408L352.044 485.065",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.615 442.597L352.044 485.722",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.592 446.101L352.044 485.942",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.691 451.354L352.044 485.941",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.694 458.142L352.044 485.944",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.51 466.458L352.48 485.94",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.232 475.654L352.262 485.941",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.42 485.722L351.823 486.161",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.546 495.791L352.483 486.161",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.261 505.204L352.044 486.158",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.446 514.179L351.826 485.942",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.661 522.058L352.266 486.158",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.559 527.752L351.823 485.94",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.71 530.158L351.826 485.94",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.701 467.554L351.826 486.161",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.075 476.966L351.606 486.161",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2 486.816L352.045 485.942",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.855 496.666L351.825 486.158",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 506.298L352.483 485.942",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.078 515.055L351.606 486.161",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.084 522.497L352.262 485.722",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4 528.187L352.04 485.719",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.251 530.815L352.043 485.501",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.664 532.127L352.044 485.722",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.516 531.909L351.823 485.722",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.28 455.733L327.31 452.888",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.367 460.986L320.74 459.016",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.989 467.554L316.145 465.802",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.705 474.78L312.421 473.905",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.173 482.876L311.107 482.438",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.391 490.755L311.107 491.194",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.144 498.418L313.078 499.731",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.646 505.422L316.801 507.174",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.242 511.772L321.833 514.182",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.372 517.025L328.401 519.87",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.282 451.354L334.751 448.509",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.724 448.947L342.85 445.663",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.604 444.567V448.069",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.362 445.446L359.705 448.73",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.681 448.073L367.149 451.139",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.124 452.45L374.153 455.077",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.559 518.997L374.589 516.37",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 523.371L367.586 520.526",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.018 522.937L361.892 526.003",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.84 445.006L337.813 446.976",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.685 449.821L335.407 442.818",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.596 440.849L346.134 445.007",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.004 446.32L345.04 440.191",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.886 439.314L354.453 444.568",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.543 444.788L355.111 439.316",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.206 446.102L357.952 439.752",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.298 444.788L365.179 440.408",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.803 442.163L371.526 449.387",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.615 446.759L374.153 444.789",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.497 450.261L382.91 449.822",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.935 520.966L383.347 522.062",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.467 527.752L365.18 525.563",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.182 521.84L367.803 530.596",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.004 525.563L329.496 528.191",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.904 522.28L337.815 530.597",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.771 510.677L309.141 506.954",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.831 504.107L312.86 514.833",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.391 503.233L306.292 497.761",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.986 496.231L308.264 506.301",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.671 485.722L305.855 478.937",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.329 478.937L304.104 486.597",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 476.968L308.479 469.525",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3 470.839L306.075 476.532",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.392 468.647L313.078 460.548",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.674 462.958L308.479 467.337",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.771 461.204V453.105",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.929 456.39L313.517 457.921",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.935 450.917H320.522",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.898 454.637L326.43 446.977",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.546 494.478L305.196 488.35",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.672 487.693L304.761 496.666",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.427 511.772V522.281",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.025 516.37L314.174 515.056",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.027 521.625L321.176 522.499",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.557 517.683L328.401 528.191",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.058 536.069L351.167 485.501L352.041 488.346L332.777 536.065H329.055L329.058 536.069Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.714 536.947L352.701 484.631L351.826 487.476L370.651 536.947H373.717H373.714Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.823 490.102C354 490.102 355.764 488.338 355.764 486.161C355.764 483.985 354 482.221 351.823 482.221C349.647 482.221 347.883 483.985 347.883 486.161C347.883 488.338 349.647 490.102 351.823 490.102Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88 525.782L346.573 531.91",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.008 527.095L340.223 531.035",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.855 527.312L355.984 532.127",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.985 527.312L348.761 532.348",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.173 526.877L365.176 530.6",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.645 525.782L358.608 532.132",
    stroke: "#615E66",
    strokeWidth: 0.335082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.126 477H145.454V486.552H157.126V477Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.797 479.509V486.547H145.449V477.295L142.797 479.505V479.509Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.369 489.731H-1.53223V492.915H161.369V489.731Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.17372 497.69L-3.99316 494.506H164.838L162.559 497.69H-2.17372Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4516 497.69H-2.06055V536.426H15.4516V497.69Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4516 497.69H-2.06055V501.406H15.4516V497.69Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.434 497.69H144.922V501.406H162.434V497.69Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7324 522.632H1.65234V536.428H11.7324V522.632Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.329 519.446H0.592773V520.506H13.329V519.446Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56661 522.632L0.717773 520.508H13.125L11.8498 522.632H1.56661Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07897 524.755H4.83496V536.427H9.07897V524.755Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1434 512.546H3.77539V514.67H10.1434V512.546Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02052 525.816H5.89648V531.124H8.02052V525.816Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.434 497.69H144.922V536.426H162.434V497.69Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921 497.69H15.4473V500.874H144.921V497.69Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921 500.875H15.4473V505.119H144.921V500.875Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8153 505.119H15.4473V536.427H21.8153V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.329 505.119H32.9609V536.427H39.329V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4276 505.119H52.0596V536.427H58.4276V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4716 505.119H70.1035V536.427H76.4716V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8613 505.119H85.4932V536.427H91.8613V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.429 505.119H103.001V536.427H110.429V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.002 505.119H119.981V536.427H129.002V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921 505.119H135.901V536.427H144.921V505.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1634 500.875H15.4473V502.467H19.1634V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6313 502.466H15.4473V536.427H18.6313V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.925 500.875H141.209V502.467H144.925V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921 502.466H141.737V536.427H144.921V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6708 500.875H32.4268V502.467H36.6708V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1449 502.466H32.9609V536.427H36.1449V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7762 500.875H51.5322V502.467H55.7762V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2435 502.466H52.0596V536.427H55.2435V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8172 500.875H69.5732V502.467H73.8172V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2875 502.466H70.1035V536.427H73.2875V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3885 500.875H88.1445V502.467H92.3885V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8599 502.466H88.6758V536.427H91.8599V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.961 500.875H106.717V502.467H110.961V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.433 502.466H107.249V536.427H110.433V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.533 500.875H125.289V502.467H129.533V500.875Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.006 502.466H125.822V536.427H129.006V502.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.66138 488.138L-2.85547 486.546H163.762L162.568 488.138H-1.66138Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.66138 489.731L-2.85547 488.139H163.762L162.568 489.731H-1.66138Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.26942 494.507L-5.5 492.915H166.401L165.171 494.507H-4.26942Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95831 511.492C9.01063 511.492 10.6743 509.828 10.6743 507.776C10.6743 505.724 9.01063 504.06 6.95831 504.06C4.90598 504.06 3.24219 505.724 3.24219 507.776C3.24219 509.828 4.90598 511.492 6.95831 511.492Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96061 510.428C8.42528 510.428 9.61263 509.24 9.61263 507.776C9.61263 506.311 8.42528 505.124 6.96061 505.124C5.49595 505.124 4.30859 506.311 4.30859 507.776C4.30859 509.24 5.49595 510.428 6.96061 510.428Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4062 478.06L78.3263 480.184L82.3063 486.552C81.3357 486.552 79.0695 486.499 77.7942 486.288C75.2478 484.801 75.4955 481.248 75.9382 479.656L75.4062 478.064V478.06Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2881 479.119L76.2082 480.975L80.1883 486.547C79.2176 486.547 76.9514 486.502 75.6762 486.315C73.1297 485.016 73.3775 481.905 73.8201 480.512L73.2881 479.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1631 479.651L74.0832 481.377L78.0632 486.551C77.0925 486.551 74.8264 486.507 73.5512 486.336C71.0047 485.13 71.2525 482.238 71.6951 480.947L71.1631 479.651Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5117 480.71L71.4317 482.168L75.4118 486.546C74.4412 486.546 72.1749 486.51 70.8997 486.364C68.3533 485.34 68.601 482.899 69.0437 481.803L68.5117 480.71Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9199 482.838L69.84 483.768L73.82 486.554C72.8494 486.554 70.5832 486.53 69.308 486.436C66.7616 485.786 67.0093 484.231 67.452 483.532L66.9199 482.838Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.613 478.06L84.693 480.184L80.7129 486.552C81.6835 486.552 83.9498 486.499 85.225 486.288C87.7714 484.801 87.5237 481.248 87.081 479.656L87.613 478.064V478.06Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.736 479.119L86.816 480.975L82.8359 486.547C83.8066 486.547 86.0728 486.502 87.3481 486.315C89.8945 485.016 89.6468 481.905 89.2041 480.512L89.736 479.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8591 479.651L88.9389 481.377L84.959 486.551C85.9296 486.551 88.1958 486.507 89.471 486.336C92.0174 485.13 91.7697 482.238 91.327 480.947L91.8591 479.651Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5124 480.71L91.5924 482.168L87.6123 486.546C88.5829 486.546 90.8492 486.51 92.1244 486.364C94.6708 485.34 94.4231 482.899 93.9804 481.803L94.5124 480.71Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1032 482.838L93.1832 483.768L89.2031 486.554C90.1738 486.554 92.4399 486.53 93.7151 486.436C96.2616 485.786 96.0138 484.231 95.5712 483.532L96.1032 482.838Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5115 485.488C83.4158 485.488 84.9596 483.944 84.9596 482.04C84.9596 480.136 83.4158 478.592 81.5115 478.592C79.6072 478.592 78.0635 480.136 78.0635 482.04C78.0635 483.944 79.6072 485.488 81.5115 485.488Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.511 484.427C82.8299 484.427 83.8991 483.358 83.8991 482.039C83.8991 480.721 82.8299 479.651 81.511 479.651C80.1922 479.651 79.123 480.721 79.123 482.039C79.123 483.358 80.1922 484.427 81.511 484.427Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87066 505.477L1.57826 504.47C1.48079 504.133 1.73666 503.792 2.09405 503.792H3.4099C3.47894 503.792 3.54391 503.779 3.60077 503.755L6.74012 502.549C6.8782 502.496 7.03255 502.504 7.16657 502.569L10.4602 504.214C10.5942 504.283 10.7526 504.287 10.8948 504.23L11.4512 504.007C11.7436 503.889 12.0726 504.051 12.1579 504.352L12.4827 505.469C12.5152 505.583 12.5112 505.704 12.4625 505.81L12.105 506.708C12.036 506.87 12.0564 507.053 12.1538 507.199L12.3852 507.548C12.4746 507.686 12.495 507.857 12.4503 508.011L12.0806 509.112C12.0319 509.266 12.0523 509.437 12.1457 509.575L12.365 509.9C12.4706 510.058 12.4827 510.261 12.3974 510.432L12.1213 510.98C12.0482 511.13 12.0482 511.305 12.1213 511.455L12.43 512.064C12.499 512.198 12.5031 512.357 12.4462 512.499L12.1132 513.344C12.0441 513.506 12.0645 513.689 12.162 513.835L12.3406 514.103C12.4584 514.282 12.4584 514.513 12.3406 514.692L12.174 514.936C12.0685 515.094 12.0563 515.297 12.1416 515.468L12.4178 516.016C12.4909 516.166 12.4909 516.341 12.4178 516.491L12.105 517.113C12.0401 517.238 12.0523 517.389 12.1335 517.502C12.3041 517.762 12.1172 518.112 11.8045 518.112H2.21184C2.03315 518.112 1.8666 518.022 1.76507 517.876L1.562 517.571C1.45641 517.413 1.44419 517.21 1.52948 517.039L1.80572 516.491C1.87882 516.341 1.87882 516.166 1.80572 516.016L1.52948 515.468C1.44419 515.297 1.45641 515.094 1.562 514.936L1.72848 514.692C1.84625 514.513 1.84625 514.282 1.72848 514.103L1.54981 513.835C1.45234 513.689 1.43208 513.506 1.50112 513.344L1.83408 512.499C1.89093 512.357 1.88686 512.198 1.81781 512.064L1.50915 511.455C1.43605 511.305 1.43605 511.13 1.50915 510.98L1.80572 510.391C1.87882 510.241 1.87882 510.066 1.80572 509.916L1.49706 509.307C1.42802 509.173 1.42394 509.014 1.4808 508.872L1.81375 508.027C1.88279 507.865 1.86254 507.682 1.76507 507.536L1.54168 507.203C1.44421 507.057 1.42395 506.874 1.49299 506.712L1.85034 505.814C1.89907 505.704 1.90315 505.583 1.87066 505.473V505.477Z",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.718 522.632H148.638V536.428H158.718V522.632Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.309 519.446H147.573V520.506H160.309V519.446Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.552 522.632L147.703 520.508H160.11L158.835 522.632H148.552Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.065 524.755H151.821V536.427H156.065V524.755Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.125 512.546H150.757V514.67H157.125V512.546Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.006 525.816H152.882V531.124H155.006V525.816Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.942 511.492C155.994 511.492 157.658 509.828 157.658 507.776C157.658 505.724 155.994 504.06 153.942 504.06C151.889 504.06 150.226 505.724 150.226 507.776C150.226 509.828 151.889 511.492 153.942 511.492Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94 510.428C155.405 510.428 156.592 509.24 156.592 507.776C156.592 506.311 155.405 505.124 153.94 505.124C152.475 505.124 151.288 506.311 151.288 507.776C151.288 509.24 152.475 510.428 153.94 510.428Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.852 505.477L148.56 504.47C148.462 504.133 148.718 503.792 149.075 503.792H150.391C150.46 503.792 150.525 503.779 150.582 503.755L153.726 502.549C153.864 502.496 154.018 502.504 154.148 502.569L157.442 504.214C157.576 504.283 157.734 504.287 157.876 504.23L158.433 504.007C158.725 503.889 159.054 504.051 159.139 504.352L159.464 505.469C159.497 505.583 159.493 505.704 159.444 505.81L159.086 506.708C159.017 506.87 159.038 507.053 159.135 507.199L159.367 507.548C159.456 507.686 159.476 507.857 159.432 508.011L159.062 509.112C159.013 509.266 159.034 509.437 159.127 509.575L159.346 509.9C159.452 510.058 159.464 510.261 159.379 510.432L159.103 510.98C159.03 511.13 159.03 511.305 159.103 511.455L159.411 512.064C159.48 512.198 159.485 512.357 159.428 512.499L159.095 513.344C159.026 513.506 159.046 513.689 159.143 513.835L159.322 514.103C159.44 514.282 159.44 514.513 159.322 514.692L159.16 514.936C159.054 515.094 159.042 515.297 159.127 515.468L159.403 516.016C159.476 516.166 159.476 516.341 159.403 516.491L159.091 517.113C159.026 517.238 159.038 517.389 159.119 517.502C159.29 517.762 159.103 518.112 158.79 518.112H149.197C149.019 518.112 148.852 518.022 148.751 517.876L148.548 517.571C148.442 517.413 148.43 517.21 148.515 517.039L148.791 516.491C148.864 516.341 148.864 516.166 148.791 516.016L148.515 515.468C148.43 515.297 148.442 515.094 148.548 514.936L148.71 514.692C148.828 514.513 148.828 514.282 148.71 514.103L148.531 513.835C148.434 513.689 148.414 513.506 148.483 513.344L148.816 512.499C148.872 512.357 148.868 512.198 148.799 512.064L148.491 511.455C148.418 511.305 148.418 511.13 148.491 510.98L148.787 510.391C148.86 510.241 148.86 510.066 148.787 509.916L148.479 509.307C148.409 509.173 148.405 509.014 148.462 508.872L148.795 508.027C148.864 507.865 148.844 507.682 148.747 507.536L148.523 507.203C148.426 507.057 148.405 506.874 148.474 506.712L148.832 505.814C148.881 505.704 148.885 505.583 148.852 505.473V505.477Z",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9143 477H3.24219V486.552H14.9143V477Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5719 479.509V486.547H14.9199V477.295L17.5719 479.505V479.509Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.819294 480.841L1.83461 486.12C1.88335 486.372 2.10673 486.551 2.35853 486.551H59.4924C59.7848 486.551 60.0245 486.311 60.0245 486.019V484.614C60.0245 484.492 59.9839 484.374 59.9067 484.281L59.0579 483.221C58.993 483.139 58.9564 483.042 58.9483 482.94L58.7046 480.516C58.7005 480.467 58.6883 480.422 58.672 480.378L57.9776 478.575C57.8192 478.152 57.1979 478.221 57.1329 478.672C57.0639 479.143 56.4059 479.188 56.2719 478.729L56.2515 478.644C56.1175 478.193 55.4759 478.205 55.3662 478.66L55.2119 479.273C55.0942 479.744 54.4158 479.728 54.3184 479.253L54.2453 478.871C54.1641 478.485 53.6199 478.473 53.5224 478.855L53.4899 478.989C53.4005 479.338 52.901 479.326 52.832 478.973C52.7629 478.64 52.2959 478.603 52.1781 478.924L51.9345 479.606C51.8086 479.947 51.3172 479.927 51.2237 479.578C51.1141 479.184 50.5455 479.224 50.4927 479.626L50.4805 479.691C50.4277 480.118 49.8226 480.146 49.7211 479.728L49.4652 478.635C49.3677 478.246 48.8235 478.217 48.6976 478.603L48.6002 478.883C48.4824 479.232 47.9747 479.172 47.9422 478.806C47.9097 478.445 47.4102 478.376 47.2884 478.717L47.1503 479.086C47.0163 479.46 46.4883 479.46 46.3543 479.086L46.1472 478.514C46.0091 478.136 45.4689 478.164 45.3673 478.554L45.3105 478.786C45.2212 479.159 44.681 479.139 44.6161 478.757C44.5511 478.388 44.0312 478.351 43.9216 478.713L43.6901 479.48C43.5845 479.817 43.1012 479.797 43.0281 479.456L42.9956 479.306C42.9306 479.017 42.5326 478.989 42.427 479.265C42.3173 479.557 41.8869 479.501 41.8544 479.192V479.143C41.8178 478.818 41.367 478.761 41.2533 479.07L41.1518 479.346C41.0178 479.712 40.4898 479.659 40.4289 479.273L40.3802 478.973C40.3274 478.611 39.8197 478.595 39.7344 478.948L39.7222 478.993C39.641 479.342 39.1374 479.318 39.0927 478.964L39.0643 478.761C39.0156 478.428 38.5322 478.42 38.4876 478.757C38.4348 479.074 37.9881 479.094 37.915 478.786L37.8419 478.489C37.7525 478.128 37.2326 478.136 37.1514 478.501L37.0864 478.794C36.989 479.241 36.3554 479.241 36.2579 478.794L36.2417 478.725C36.1442 478.278 35.5188 478.258 35.3929 478.696L35.2955 479.025C35.1533 479.525 34.4467 479.529 34.2923 479.029C34.138 478.522 33.4151 478.534 33.277 479.046L33.2364 479.208C33.0942 479.74 32.3348 479.732 32.2089 479.192L32.0505 478.51C31.949 478.095 31.356 478.103 31.2747 478.522L31.2423 478.66C31.1611 479.066 30.5803 479.054 30.5153 478.644C30.4585 478.266 29.9386 478.213 29.8046 478.566L29.6097 479.074C29.4472 479.509 28.8096 479.431 28.7446 478.973C28.6796 478.485 27.9892 478.441 27.8633 478.916L27.7902 479.208C27.6643 479.671 27.0145 479.7 26.8561 479.249L26.7831 479.054C26.6409 478.664 26.0844 478.688 25.9748 479.086C25.857 479.513 25.2479 479.501 25.1464 479.07L25.0245 478.53C24.927 478.124 24.3788 478.071 24.2082 478.453L24.0579 478.782C23.936 479.058 23.5259 479.017 23.4649 478.721C23.3918 478.388 22.9126 478.396 22.8476 478.729L22.738 479.277C22.6648 479.647 22.1288 479.63 22.0801 479.257C22.0313 478.883 21.4952 478.867 21.4221 479.237L21.3816 479.44C21.3003 479.834 20.7399 479.834 20.6586 479.44L20.618 479.237C20.5368 478.826 19.9479 478.834 19.8748 479.245C19.8017 479.671 19.1803 479.639 19.1275 479.208C19.0788 478.798 18.498 478.741 18.3883 479.143C18.2909 479.488 17.8157 479.521 17.6776 479.192L17.6614 479.155C17.5233 478.843 17.0765 478.839 16.9384 479.151L16.6379 479.838C16.4673 480.219 15.9435 480.264 15.708 479.915L15.0134 478.871C14.855 478.631 14.4936 478.652 14.3596 478.912C14.2012 479.237 13.7179 479.168 13.6529 478.81L13.6407 478.741C13.5595 478.323 12.9707 478.294 12.857 478.709L12.8366 478.798C12.731 479.18 12.2112 479.22 12.0447 478.863L11.6182 477.925C11.4761 477.616 11.0253 477.653 10.9319 477.978L10.7979 478.461C10.7166 478.753 10.2902 478.717 10.2617 478.412C10.2333 478.112 9.81508 478.071 9.72573 478.359L9.65255 478.619C9.55508 478.928 9.12051 478.928 9.0271 478.619L8.95809 478.388C8.84032 478.002 8.28803 478.014 8.19462 478.404L8.14584 478.587C8.05649 478.96 7.52042 478.94 7.45138 478.562C7.3864 478.205 6.89501 478.164 6.76505 478.506L6.64319 478.843C6.49292 479.257 5.89586 479.232 5.77809 478.806L5.70501 478.538C5.60348 478.156 5.06744 478.144 4.94154 478.518C4.82376 478.883 4.30388 478.883 4.1861 478.518L4.16578 478.461C4.03988 478.079 3.49568 478.079 3.36978 478.461L3.18298 479.021C3.09363 479.293 2.73216 479.358 2.55753 479.135C2.33822 478.867 1.91175 479.017 1.91175 479.362V480.386C1.91175 480.678 1.54629 480.808 1.35947 480.585C1.15235 480.337 0.754305 480.528 0.811163 480.845L0.819294 480.841Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.083 480.841L159.068 486.12C159.019 486.372 158.796 486.551 158.544 486.551H101.41C101.118 486.551 100.878 486.311 100.878 486.019V484.614C100.878 484.492 100.919 484.374 100.996 484.281L101.844 483.221C101.909 483.139 101.946 483.042 101.954 482.94L102.198 480.516C102.202 480.467 102.214 480.422 102.23 480.378L102.925 478.575C103.083 478.152 103.705 478.221 103.77 478.672C103.839 479.143 104.497 479.188 104.631 478.729L104.651 478.644C104.785 478.193 105.427 478.205 105.536 478.66L105.69 479.273C105.808 479.744 106.487 479.728 106.584 479.253L106.657 478.871C106.738 478.485 107.283 478.473 107.38 478.855L107.412 478.989C107.502 479.338 108.001 479.326 108.07 478.973C108.139 478.64 108.606 478.603 108.724 478.924L108.968 479.606C109.094 479.947 109.585 479.927 109.679 479.578C109.788 479.184 110.357 479.224 110.41 479.626L110.422 479.691C110.475 480.118 111.08 480.146 111.181 479.728L111.437 478.635C111.535 478.246 112.079 478.217 112.205 478.603L112.302 478.883C112.42 479.232 112.928 479.172 112.96 478.806C112.993 478.445 113.492 478.376 113.614 478.717L113.752 479.086C113.886 479.46 114.414 479.46 114.548 479.086L114.755 478.514C114.893 478.136 115.433 478.164 115.535 478.554L115.592 478.786C115.681 479.159 116.221 479.139 116.286 478.757C116.351 478.388 116.871 478.351 116.981 478.713L117.212 479.48C117.318 479.817 117.801 479.797 117.874 479.456L117.907 479.306C117.972 479.017 118.37 478.989 118.475 479.265C118.585 479.557 119.016 479.501 119.048 479.192V479.143C119.085 478.818 119.535 478.761 119.649 479.07L119.751 479.346C119.885 479.712 120.413 479.659 120.474 479.273L120.522 478.973C120.575 478.611 121.083 478.595 121.168 478.948L121.18 478.993C121.261 479.342 121.765 479.318 121.81 478.964L121.838 478.761C121.887 478.428 122.37 478.42 122.415 478.757C122.468 479.074 122.914 479.094 122.987 478.786L123.061 478.489C123.15 478.128 123.67 478.136 123.751 478.501L123.816 478.794C123.913 479.241 124.547 479.241 124.644 478.794L124.661 478.725C124.758 478.278 125.384 478.258 125.509 478.696L125.607 479.025C125.749 479.525 126.456 479.529 126.61 479.029C126.764 478.522 127.487 478.534 127.625 479.046L127.666 479.208C127.808 479.74 128.568 479.732 128.694 479.192L128.852 478.51C128.953 478.095 129.546 478.103 129.628 478.522L129.66 478.66C129.741 479.066 130.322 479.054 130.387 478.644C130.444 478.266 130.964 478.213 131.098 478.566L131.293 479.074C131.459 479.509 132.093 479.431 132.158 478.973C132.223 478.485 132.913 478.441 133.039 478.916L133.112 479.208C133.238 479.671 133.888 479.7 134.046 479.249L134.119 479.054C134.262 478.664 134.818 478.688 134.928 479.086C135.045 479.513 135.655 479.501 135.756 479.07L135.878 478.53C135.975 478.124 136.524 478.071 136.694 478.453L136.845 478.782C136.966 479.058 137.377 479.017 137.437 478.721C137.511 478.388 137.99 478.396 138.055 478.729L138.164 479.277C138.238 479.647 138.774 479.63 138.822 479.257C138.871 478.883 139.407 478.867 139.48 479.237L139.521 479.44C139.602 479.834 140.163 479.834 140.244 479.44L140.284 479.237C140.366 478.826 140.954 478.834 141.028 479.245C141.101 479.671 141.722 479.639 141.775 479.208C141.824 478.798 142.404 478.741 142.514 479.143C142.612 479.488 143.087 479.521 143.225 479.192L143.241 479.155C143.379 478.843 143.826 478.839 143.964 479.151L144.264 479.838C144.435 480.219 144.959 480.264 145.194 479.915L145.889 478.871C146.047 478.631 146.409 478.652 146.543 478.912C146.701 479.237 147.184 479.168 147.249 478.81L147.262 478.741C147.343 478.323 147.932 478.294 148.045 478.709L148.066 478.798C148.171 479.18 148.691 479.22 148.858 478.863L149.284 477.925C149.426 477.616 149.877 477.653 149.971 477.978L150.105 478.461C150.186 478.753 150.612 478.717 150.641 478.412C150.669 478.112 151.087 478.071 151.177 478.359L151.25 478.619C151.347 478.928 151.782 478.928 151.875 478.619L151.944 478.388C152.062 478.002 152.614 478.014 152.708 478.404L152.757 478.587C152.846 478.96 153.382 478.94 153.451 478.562C153.516 478.205 154.007 478.164 154.137 478.506L154.259 478.843C154.409 479.257 155.006 479.232 155.124 478.806L155.197 478.538C155.299 478.156 155.835 478.144 155.961 478.518C156.079 478.883 156.599 478.883 156.716 478.518L156.737 478.461C156.863 478.079 157.407 478.079 157.533 478.461L157.719 479.021C157.809 479.293 158.17 479.358 158.345 479.135C158.564 478.867 158.991 479.017 158.991 479.362V480.386C158.991 480.678 159.356 480.808 159.543 480.585C159.75 480.337 160.148 480.528 160.091 480.845L160.083 480.841Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.406127,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.146 486.282L101.243 481.803C101.259 481.048 101.873 480.446 102.628 480.446C103.371 480.446 103.984 481.035 104.013 481.779L104.183 486.282L104.334 481.718C104.362 481.011 104.943 480.446 105.649 480.446C106.356 480.446 106.937 481.007 106.965 481.714L107.136 486.282L107.31 481.754C107.339 481.023 107.936 480.446 108.667 480.446C109.398 480.446 109.999 481.023 110.023 481.754L110.194 486.282L110.405 481.596C110.438 480.95 110.97 480.442 111.615 480.442C112.277 480.442 112.822 480.983 112.822 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.816 486.282L112.914 481.803C112.93 481.048 113.543 480.446 114.299 480.446C115.042 480.446 115.655 481.035 115.684 481.779L115.854 486.282L116.005 481.718C116.033 481.011 116.614 480.446 117.32 480.446C118.027 480.446 118.608 481.007 118.636 481.714L118.807 486.282L118.981 481.754C119.01 481.023 119.607 480.446 120.338 480.446C121.069 480.446 121.67 481.023 121.694 481.754L121.865 486.282L122.076 481.596C122.109 480.95 122.641 480.442 123.286 480.442C123.948 480.442 124.493 480.983 124.493 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.492 486.282L124.59 481.803C124.606 481.048 125.223 480.446 125.975 480.446C126.718 480.446 127.331 481.035 127.359 481.779L127.53 486.282L127.68 481.718C127.709 481.011 128.29 480.446 128.996 480.446C129.703 480.446 130.284 481.007 130.312 481.714L130.483 486.282L130.657 481.754C130.686 481.023 131.283 480.446 132.014 480.446C132.745 480.446 133.346 481.023 133.37 481.754L133.541 486.282L133.752 481.596C133.784 480.95 134.316 480.442 134.962 480.442C135.624 480.442 136.168 480.983 136.168 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.164 486.282L136.262 481.803C136.278 481.048 136.895 480.446 137.646 480.446C138.39 480.446 139.003 481.035 139.031 481.779L139.202 486.282L139.352 481.718C139.381 481.011 139.961 480.446 140.668 480.446C141.375 480.446 141.955 481.007 141.984 481.714L142.154 486.282L142.329 481.754C142.357 481.023 142.955 480.446 143.686 480.446C144.417 480.446 145.018 481.023 145.042 481.754L145.213 486.282L145.424 481.596C145.456 480.95 145.988 480.442 146.634 480.442C147.296 480.442 147.84 480.983 147.84 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.841 486.282L147.938 481.803C147.955 481.048 148.572 480.446 149.323 480.446C150.066 480.446 150.68 481.035 150.708 481.779L150.879 486.282L151.029 481.718C151.057 481.011 151.638 480.446 152.345 480.446C153.051 480.446 153.632 481.007 153.661 481.714L153.831 486.282L154.006 481.754C154.034 481.023 154.631 480.446 155.362 480.446C156.093 480.446 156.694 481.023 156.719 481.754L156.889 486.282L157.101 481.596C157.133 480.95 157.665 480.442 158.311 480.442C158.973 480.442 159.517 480.983 159.517 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.855469 486.282L0.952935 481.803C0.96918 481.048 1.5824 480.446 2.33779 480.446C3.081 480.446 3.69432 481.035 3.72275 481.779L3.89329 486.282L4.04351 481.718C4.07193 481.011 4.65279 480.446 5.35945 480.446C6.06611 480.446 6.64687 481.007 6.6753 481.714L6.84584 486.282L7.02045 481.754C7.04888 481.023 7.64592 480.446 8.37695 480.446C9.10797 480.446 9.70898 481.023 9.73335 481.754L9.90399 486.282L10.1152 481.596C10.1477 480.95 10.6797 480.442 11.3254 480.442C11.9874 480.442 12.5316 480.983 12.5316 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5322 486.282L12.6297 481.803C12.6459 481.048 13.2592 480.446 14.0146 480.446C14.7578 480.446 15.3711 481.035 15.3995 481.779L15.57 486.282L15.7203 481.718C15.7487 481.011 16.3295 480.446 17.0362 480.446C17.7429 480.446 18.3236 481.007 18.3521 481.714L18.5226 486.282L18.6972 481.754C18.7256 481.023 19.3227 480.446 20.0537 480.446C20.7847 480.446 21.3857 481.023 21.4101 481.754L21.5807 486.282L21.7919 481.596C21.8244 480.95 22.3564 480.442 23.0022 480.442C23.6642 480.442 24.2084 480.983 24.2084 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2021 486.282L24.2996 481.803C24.3159 481.048 24.9291 480.446 25.6845 480.446C26.4277 480.446 27.041 481.035 27.0694 481.779L27.24 486.282L27.3903 481.718C27.4187 481.011 27.9995 480.446 28.7061 480.446C29.4128 480.446 29.9935 481.007 30.022 481.714L30.1925 486.282L30.3671 481.754C30.3956 481.023 30.9926 480.446 31.7236 480.446C32.4547 480.446 33.0557 481.023 33.08 481.754L33.2507 486.282L33.4619 481.596C33.4944 480.95 34.0264 480.442 34.6721 480.442C35.3341 480.442 35.8783 480.983 35.8783 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.876 486.282L35.9734 481.803C35.9897 481.048 36.6029 480.446 37.3583 480.446C38.1015 480.446 38.7148 481.035 38.7433 481.779L38.9138 486.282L39.0641 481.718C39.0925 481.011 39.6733 480.446 40.38 480.446C41.0866 480.446 41.6674 481.007 41.6958 481.714L41.8663 486.282L42.041 481.754C42.0694 481.023 42.6664 480.446 43.3975 480.446C44.1285 480.446 44.7296 481.023 44.754 481.754L44.9245 486.282L45.1357 481.596C45.1682 480.95 45.7002 480.442 46.3459 480.442C47.0079 480.442 47.5521 480.983 47.5521 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5508 486.282L47.6482 481.803C47.6645 481.048 48.2777 480.446 49.0331 480.446C49.7763 480.446 50.3896 481.035 50.4181 481.779L50.5886 486.282L50.7389 481.718C50.7673 481.011 51.3481 480.446 52.0548 480.446C52.7614 480.446 53.3422 481.007 53.3706 481.714L53.5412 486.282L53.7158 481.754C53.7442 481.023 54.3412 480.446 55.0723 480.446C55.8033 480.446 56.4044 481.023 56.4288 481.754L56.5993 486.282L56.8105 481.596C56.843 480.95 57.375 480.442 58.0207 480.442C58.6827 480.442 59.2269 480.983 59.2269 481.649V486.278",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7324 488.139H1.65234V491.323H11.7324V488.139Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4865 489.731H35.0786C35.9558 489.731 36.6706 490.442 36.6706 491.323C36.6706 492.2 35.9599 492.915 35.0786 492.915H33.4865C32.6093 492.915 31.8945 492.204 31.8945 491.323C31.8945 490.446 32.6052 489.731 33.4865 489.731Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.454 482.315C147.237 482.449 148.638 483.94 148.638 485.755V486.551H145.454V482.315Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.369 482.315C159.586 482.449 158.185 483.94 158.185 485.755V486.551H161.369V482.315Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.433 483.894C110.433 483.017 109.722 482.302 108.841 482.302C107.96 482.302 107.249 483.013 107.249 483.894V486.546H110.433V483.894Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.001 483.894C129.001 483.017 128.291 482.302 127.409 482.302C126.528 482.302 125.817 483.013 125.817 483.894V486.546H129.001V483.894Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.591 489.731H54.1831C55.0603 489.731 55.7751 490.442 55.7751 491.323C55.7751 492.2 55.0644 492.915 54.1831 492.915H52.591C51.7138 492.915 50.999 492.204 50.999 491.323C50.999 490.446 51.7097 489.731 52.591 489.731Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.309 489.731H109.901C110.778 489.731 111.493 490.442 111.493 491.323C111.493 492.2 110.782 492.915 109.901 492.915H108.309C107.432 492.915 106.717 492.204 106.717 491.323C106.717 490.446 107.428 489.731 108.309 489.731Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.881 489.731H128.473C129.35 489.731 130.065 490.442 130.065 491.323C130.065 492.2 129.35 492.915 128.473 492.915H126.881C126.004 492.915 125.289 492.204 125.289 491.323C125.289 490.446 126.004 489.731 126.881 489.731Z",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.00098 482.315C0.78192 482.449 2.18309 483.94 2.18309 485.755V486.551H-1.00098V482.315Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9193 482.315C13.1364 482.449 11.7354 483.94 11.7354 485.755V486.551H14.9193V482.315Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6108 483.894C35.6108 483.017 34.9 482.302 34.0187 482.302C33.1374 482.302 32.4268 483.013 32.4268 483.894V486.546H35.6108V483.894Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7162 483.894C54.7162 483.017 54.0055 482.302 53.1242 482.302C52.2429 482.302 51.5322 483.013 51.5322 483.894V486.546H54.7162V483.894Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.718 488.139H148.638V491.323H158.718V488.139Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.406127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365.304 546.48H717.622V563.713H-365.304V546.48Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.304 551.963L-359.276 551.863",
    stroke: "white",
    strokeWidth: 0.555604,
    strokeDasharray: "2.78 2.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365.304 563.423H717.622V567.868H-365.304V563.423Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365.304 542.032H717.622V546.477H-365.304V542.032Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365.304 537.893H717.622V544.759H-365.304V537.893Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.058 544.76H493.138L567.778 542.756H656.619L717.058 544.76Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.388 544.76H301.486L365.227 542.756H454.067L563.385 544.76H563.388Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.176 544.76H-66.4274L40.2491 542.756H247.986L335.176 544.76Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.87 547.635C319.002 546.89 311.371 546.951 308.307 546.992C307.519 547.003 306.772 547.331 306.229 547.899L303.297 550.969C303.297 550.969 295.424 552.005 295.424 552.768V555.681C295.251 555.896 294.887 556.513 294.84 557.246C294.802 557.85 295.262 558.833 295.623 559.475C295.749 559.704 295.995 559.836 296.257 559.836H333.157C333.579 559.836 333.918 559.498 333.918 559.076V554.389C333.918 553.636 332.284 553.308 331.168 553.143C330.049 552.978 327.241 552.639 324.896 552.063C324.896 552.063 323.284 548.001 321.87 547.635Z",
    fill: "#F176A9",
    stroke: "#382456",
    strokeWidth: 0.275564
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M301.498 554.75C304.091 553.885 306.059 555.111 306.72 555.83C306.962 555.951 307.475 556.081 307.621 555.651C306.18 554.031 303.3 553.49 301.501 554.75H301.498Z",
    fill: "url(#paint6_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.763 556.189C317.164 556.189 330.84 556.189 333.362 556.729V559.25H295.557C295.315 558.771 294.838 557.702 294.838 557.269C294.838 556.837 295.317 556.01 295.557 555.649C297.717 555.588 308.159 556.189 311.757 556.189H311.76H311.763Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.086 553.036L295.487 552.675L295.46 554.438L298.127 553.783C298.535 553.683 298.505 553.094 298.089 553.036H298.086Z",
    fill: "#C86A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.732 561.727C330.657 561.727 332.218 560.134 332.218 558.17C332.218 556.205 330.657 554.612 328.732 554.612C326.807 554.612 325.246 556.205 325.246 558.17C325.246 560.134 326.807 561.727 328.732 561.727Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.732 559.783C329.606 559.783 330.314 559.061 330.314 558.169C330.314 557.278 329.606 556.555 328.732 556.555C327.859 556.555 327.15 557.278 327.15 558.169C327.15 559.061 327.859 559.783 328.732 559.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.424 561.727C305.35 561.727 306.91 560.134 306.91 558.17C306.91 556.205 305.35 554.612 303.424 554.612C301.499 554.612 299.938 556.205 299.938 558.17C299.938 560.134 301.499 561.727 303.424 561.727Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.425 559.783C304.298 559.783 305.006 559.061 305.006 558.169C305.006 557.278 304.298 556.555 303.425 556.555C302.551 556.555 301.843 557.278 301.843 558.169C301.843 559.061 302.551 559.783 303.425 559.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65 552.225H324.254L321.843 548.268L314.102 547.728H307.621L304.201 551.33C304.201 551.33 309.241 552.225 313.653 552.225H313.65Z",
    fill: "url(#paint7_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65 552.225H324.254L321.843 548.268L314.102 547.728H307.621L304.201 551.33C304.201 551.33 309.241 552.225 313.653 552.225H313.65Z",
    fill: "url(#paint8_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.836 547.864H314.582V552.419H314.836V547.864Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.192895
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.642 552.172L321.406 548.304V550.214L318.239 552.172H316.642Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.821 552.224L319.331 548.067L320.392 548.209L315.652 552.224H314.821Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.968 545.598C349.637 545.598 351.8 547.762 351.8 550.43C351.8 553.099 349.637 555.263 346.968 555.263C344.299 555.263 342.136 553.099 342.136 550.43C342.136 547.762 344.299 545.598 346.968 545.598Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.969 547.411H347.373C349.487 547.411 351.197 549.124 351.197 551.235C351.197 553.349 349.484 555.06 347.373 555.06H346.969C344.855 555.06 343.145 553.346 343.145 551.235C343.145 549.121 344.858 547.411 346.969 547.411Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.768 551.033V565.931",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.587 551.439L346.768 554.259",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.151 551.439L346.971 554.259",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.412 545.598C356.081 545.598 358.245 547.762 358.245 550.43C358.245 553.099 356.081 555.263 353.412 555.263C350.744 555.263 348.58 553.099 348.58 550.43C348.58 547.762 350.744 545.598 353.412 545.598Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.412 547.411H353.815C355.929 547.411 357.64 549.124 357.64 551.235C357.64 553.349 355.926 555.06 353.815 555.06H353.412C351.297 555.06 349.587 553.346 349.587 551.235C349.587 549.121 351.3 547.411 353.412 547.411Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.212 551.033V565.931",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.029 551.439L353.209 554.259",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.593 551.439L353.413 554.259",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.855 545.598C362.524 545.598 364.687 547.762 364.687 550.43C364.687 553.099 362.524 555.263 359.855 555.263C357.186 555.263 355.022 553.099 355.022 550.43C355.022 547.762 357.186 545.598 359.855 545.598Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.854 547.411H360.258C362.372 547.411 364.082 549.124 364.082 551.235C364.082 553.349 362.369 555.06 360.258 555.06H359.854C357.74 555.06 356.029 553.346 356.029 551.235C356.029 549.121 357.743 547.411 359.854 547.411Z",
    fill: "#2FE076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.652 551.033V565.931",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.472 551.439L359.652 554.259",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.037 551.439L359.857 554.259",
    stroke: "#382456",
    strokeWidth: 0.308185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.644 548.13C320.766 547.384 313.112 547.445 310.038 547.486C309.247 547.497 308.498 547.826 307.954 548.396L305.012 551.475C305.012 551.475 297.115 552.514 297.115 553.28V556.202C296.94 556.418 296.576 557.037 296.529 557.772C296.49 558.378 296.952 559.364 297.314 560.009C297.441 560.238 297.687 560.371 297.949 560.371H334.966C335.389 560.371 335.729 560.031 335.729 559.608V554.906C335.729 554.151 334.09 553.822 332.971 553.656C331.848 553.49 329.031 553.15 326.679 552.573C326.679 552.573 325.062 548.498 323.644 548.13Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M303.207 555.268C305.808 554.4 307.782 555.63 308.445 556.352C308.689 556.473 309.203 556.603 309.349 556.172C307.904 554.547 305.015 554.005 303.21 555.268H303.207Z",
    fill: "url(#paint9_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.505 556.712C318.923 556.712 332.642 556.712 335.171 557.253V559.783H297.248C297.005 559.302 296.526 558.229 296.526 557.795C296.526 557.361 297.007 556.532 297.248 556.17C299.415 556.109 309.889 556.712 313.499 556.712H313.502H313.505Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.785 553.549L297.178 553.187L297.15 554.956L299.826 554.298C300.235 554.198 300.205 553.607 299.787 553.549H299.785Z",
    fill: "#C86A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.527 562.267C332.458 562.267 334.024 560.669 334.024 558.698C334.024 556.727 332.458 555.129 330.527 555.129C328.596 555.129 327.03 556.727 327.03 558.698C327.03 560.669 328.596 562.267 330.527 562.267Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.527 560.317C331.403 560.317 332.114 559.593 332.114 558.698C332.114 557.804 331.403 557.079 330.527 557.079C329.651 557.079 328.94 557.804 328.94 558.698C328.94 559.593 329.651 560.317 330.527 560.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.14 562.267C307.072 562.267 308.637 560.669 308.637 558.698C308.637 556.727 307.072 555.129 305.14 555.129C303.209 555.129 301.644 556.727 301.644 558.698C301.644 560.669 303.209 562.267 305.14 562.267Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.14 560.317C306.017 560.317 306.727 559.593 306.727 558.698C306.727 557.804 306.017 557.079 305.14 557.079C304.264 557.079 303.554 557.804 303.554 558.698C303.554 559.593 304.264 560.317 305.14 560.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.399 552.735H326.036L323.617 548.765L315.852 548.224H309.35L305.92 551.837C305.92 551.837 310.976 552.735 315.401 552.735H315.399Z",
    fill: "url(#paint10_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.399 552.735H326.036L323.617 548.765L315.852 548.224H309.35L305.92 551.837C305.92 551.837 310.976 552.735 315.401 552.735H315.399Z",
    fill: "url(#paint11_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.587 548.36H316.333V552.929H316.587V548.36Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.193502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.399 552.682L323.179 548.802V550.718L320.001 552.682H318.399Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.573 552.735L321.097 548.564L322.161 548.707L317.406 552.735H316.573Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38281 537.539V538.216L28.0709 538.081L18.8768 537H7.92461C7.62606 537 7.38281 537.243 7.38281 537.542V537.539Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.5 539.839C-27.5 538.794 -26.6513 537.945 -25.6064 537.945H44.4883C46.1442 537.945 47.6922 538.766 48.621 540.14C49.8787 542.003 50.8711 544.032 51.565 546.172L51.6064 546.302C52.0487 547.665 52.2754 549.086 52.2754 550.517V556.875C52.2754 557.92 51.4267 558.769 50.3818 558.769H-25.6064C-26.6513 558.769 -27.5 557.92 -27.5 556.875V539.839Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.058 541.263L53.221 542.004L52.2757 542.41C52.2757 541.175 51.1147 540.268 49.9149 540.566L49.0303 540.788L48.085 539.571H50.946C51.9605 539.571 52.8368 540.276 53.058 541.266V541.263Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.9609 551.062H42.3847",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19629 551.195V558.766",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7422 551.195V558.766",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0166 551.195V558.766",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1621 551.195V558.766",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3818 551.735V558.765",
    stroke: "#76736C",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.6095 548.898V547.275H32.2614C35.0727 547.275 36.4991 547.725 36.8585 547.952L44.0236 550.927L48.6206 551.737H52.2723C52.3635 552.096 52.4879 552.953 52.2723 553.495C50.1079 553.63 44.9717 553.359 44.0236 552.817C39.8052 549.788 35.9545 548.942 34.5586 548.895H-25.6123L-25.6095 548.898Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1553 562.286C36.2468 562.286 37.9424 560.53 37.9424 558.363C37.9424 556.197 36.2468 554.441 34.1553 554.441C32.0637 554.441 30.3682 556.197 30.3682 558.363C30.3682 560.53 32.0637 562.286 34.1553 562.286Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0198 560.12C34.9908 560.12 35.7779 559.333 35.7779 558.362C35.7779 557.391 34.9908 556.604 34.0198 556.604C33.0488 556.604 32.2617 557.391 32.2617 558.362C32.2617 559.333 33.0488 560.12 34.0198 560.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86954 557.417H1.70508V558.498H3.86954V557.417Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4154 557.417H12.251V558.498H14.4154V557.417Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6938 557.417H22.5293V558.498H24.6938V557.417Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0816 553.359H41.459V554.44H43.0816V553.359Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0816 555.795H41.459V556.876H43.0816V555.795Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.6095 540.649C-25.6095 540.052 -25.1258 539.568 -24.5287 539.568H44.2917C45.4583 539.568 46.6193 539.748 47.7305 540.102L47.8135 540.13C48.593 540.378 49.2454 540.915 49.6407 541.633L50.6579 543.485C52.0622 546.045 52.6731 548.967 52.4078 551.875H48.6206L44.0236 551.065L37.9393 548.5C36.242 547.784 34.4204 547.416 32.5793 547.416H-25.6123V540.655L-25.6095 540.649Z",
    fill: "url(#paint12_linear_6004_62530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3438 539.978L49.1979 541.91C50.6022 545.092 51.3265 548.531 51.3265 552.008",
    stroke: "white",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3711 547.419L38.4844 538.571H41.304L30.3711 549.437V547.419Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6133 547.953L37.1329 538.624L37.4812 539.107L28.616 548.437V547.953H28.6133Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5371 547.419L18.6504 538.571V541.056L10.5371 549.44V547.422V547.419Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7793 547.953L17.2989 538.624L17.6472 539.107L8.78206 548.437V547.953H8.7793Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19531 539.568V547.745",
    stroke: "white",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7412 539.568V548.105",
    stroke: "white",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0166 539.568V547.925",
    stroke: "white",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1621 539.568V551.198",
    stroke: "white",
    strokeWidth: 0.276432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5833 545.157V542.365C53.5833 542.166 53.4202 542.003 53.2212 542.003H52.8148C52.367 542.003 52.0049 542.365 52.0049 542.813V544.706C52.0049 545.154 52.367 545.519 52.8148 545.519H53.2212C53.4202 545.519 53.5833 545.356 53.5833 545.157Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.338 662.699V566.854H-379.425V662.699H727.338Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.153 816.906H-379.722V652.056H738.153V816.906Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.001 585.35L-129.796 587.846L14.1068 652.118H351.901L334.001 585.35Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.796 587.846H-303.995L-304.5 602.198H-166.226C-165.509 602.198 -164.799 602.334 -164.133 602.6L-130.968 615.846L-61.1268 652.118H14.1068L-129.796 587.846Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.1268 652.118L-130.968 615.846H-298.767L-298.441 652.118H-61.1268Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.164 652.118L495.299 651.806L683.131 652.118L685.428 607.503L459.082 606.707C432.93 606.615 407.319 599.256 385.107 585.452L383.961 584.739C381.538 583.233 382.625 579.493 385.478 579.521L690.476 582.542V571.934L339.015 570.765C331.238 570.739 327.852 580.588 334.001 585.35V585.35L351.901 652.118H430.164Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.686 652C340.686 652 343.421 649.65 343.499 647.202C343.576 644.755 339.841 647.202 339.841 647.202C339.841 647.202 340.462 646.151 339.609 645.879C338.755 645.611 336.883 647.349 336.883 647.349C336.883 647.349 336.832 642.746 333.353 642.321C329.878 641.897 328.892 644.41 328.892 644.41C328.892 644.41 328.216 642.551 326.92 642.516C325.623 642.485 325.828 643.888 325.828 643.888C325.828 643.888 324.166 641.604 320.121 642.06C316.075 642.516 315.4 646.074 315.4 646.074C315.4 646.074 314.117 644.926 312.911 645.169C311.706 645.413 312.482 647.885 312.482 647.885C312.482 647.885 310.304 644.703 308.825 644.678C307.345 644.654 308.359 647.394 308.359 647.394C308.359 647.394 306.765 643.992 301.861 643.355C296.958 642.718 298.711 646.997 298.711 646.997C298.711 646.997 296.725 645.705 295.56 646.071C294.396 646.437 296.611 648.985 296.611 648.985C296.611 648.985 293.771 647.686 291.981 648.226C290.191 648.766 293.976 651.997 293.976 651.997H340.682L340.686 652Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.283048
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7563 642.494C19.7563 642.494 12.367 644.784 15.1108 652H66.3808C66.959 651.029 67.3765 649.91 67.5 648.633C65.0611 643.513 60.7458 644.034 60.7458 644.034C60.7458 644.034 62.8455 641.832 61.7416 641.517C60.6376 641.201 58.7544 642.317 58.7544 642.317C58.7544 642.317 60.4168 638.62 55.7672 639.171C51.1175 639.721 49.6066 642.659 49.6066 642.659C49.6066 642.659 50.5677 640.293 49.165 640.314C47.7623 640.335 45.6973 643.083 45.6973 643.083C45.6973 643.083 46.4333 640.948 45.2903 640.738C44.1474 640.527 42.9309 641.52 42.9309 641.52C42.9309 641.52 42.2901 638.446 38.4544 638.052C34.6187 637.658 33.0428 639.631 33.0428 639.631C33.0428 639.631 33.2376 638.419 32.0081 638.446C30.7786 638.476 30.1379 640.082 30.1379 640.082C30.1379 640.082 29.2027 637.911 25.9082 638.278C22.6093 638.644 22.5616 642.62 22.5616 642.62C22.5616 642.62 20.7866 641.12 19.9771 641.351C19.1675 641.586 19.7563 642.494 19.7563 642.494Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.283048
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6004_62530",
    x1: 187.5,
    y1: -83.2606,
    x2: 70.9036,
    y2: 760.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741703,
    stopColor: "#F7F0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6004_62530",
    x1: 187.5,
    y1: -83.2606,
    x2: 70.9036,
    y2: 760.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73693,
    stopColor: "#FCEEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741703,
    stopColor: "#FCEEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6004_62530",
    x1: 187.5,
    y1: -83.2606,
    x2: 70.9036,
    y2: 760.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741703,
    stopColor: "#F7F0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6004_62530",
    x1: 2005.2,
    y1: 584.628,
    x2: 2005.2,
    y2: 405.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6004_62530",
    x1: 2005.2,
    y1: 584.628,
    x2: 2005.2,
    y2: 405.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6004_62530",
    x1: 126.322,
    y1: 550.769,
    x2: 133.403,
    y2: 549.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6004_62530",
    x1: 307.649,
    y1: 555.232,
    x2: 299.905,
    y2: 554.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6004_62530",
    x1: 304.201,
    y1: 549.977,
    x2: 324.254,
    y2: 549.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6004_62530",
    x1: 314.228,
    y1: 547.728,
    x2: 314.228,
    y2: 552.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6004_62530",
    x1: 309.377,
    y1: 555.752,
    x2: 301.609,
    y2: 554.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6004_62530",
    x1: 305.92,
    y1: 550.479,
    x2: 326.036,
    y2: 550.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6004_62530",
    x1: 315.978,
    y1: 548.224,
    x2: 315.978,
    y2: 552.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6004_62530",
    x1: 13.428,
    y1: 539.568,
    x2: 13.428,
    y2: 551.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6004_62530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroLostBgMobile);
export default __webpack_public_path__ + "static/media/MetroLostBgMobile.fafb55f7d781161facbb.svg";
export { ForwardRef as ReactComponent };